import { Quiz } from '@/types/quiz';

export const quizAll: Quiz[] = [
  {
    quizId: '1',
    question: '化物語の絵師は？',
    options: [
      { optionId: '0', text: 'VOFAN' },
      { optionId: '1', text: 'TAGRO' },
      { optionId: '2', text: '西村キヌ' },
      { optionId: '3', text: '碧風羽' },
      { optionId: '4', text: '竹' },
    ],
  },
  {
    quizId: '2',
    question: '化物語、本文使用書体は？',
    options: [
      { optionId: '0', text: 'FOT-筑紫明朝 Pro L' },
      { optionId: '1', text: 'イワタ中明朝体オールド' },
      { optionId: '2', text: 'A-TOF リュウミン Pro R-KL' },
      { optionId: '3', text: 'DHP平成明朝W7' },
      { optionId: '4', text: 'リョービ本明朝Ｌ新がな' },
    ],
  },
  {
    quizId: '3',
    question:
      '戦場ヶ原ひたぎは線の細い、触れれば折れそうなたおやかで儚げな感じから、クラスで何といわれている？',
    options: [
      { optionId: '0', text: '深窓の令嬢' },
      { optionId: '1', text: '不動の寡黙' },
      { optionId: '2', text: '別世の命嬢' },
      { optionId: '3', text: '深窓の麗人' },
      { optionId: '4', text: '深窓の佳人' },
    ],
  },
  {
    quizId: '4',
    question: '阿良々木暦が戦場ヶ原の体重の秘密を知ったのはいつ？',
    options: [
      { optionId: '0', text: '五月八日' },
      { optionId: '1', text: '五月六日' },
      { optionId: '2', text: '五月七日' },
      { optionId: '3', text: '五月九日' },
      { optionId: '4', text: '五月十日' },
    ],
  },
  {
    quizId: '5',
    question: 'ひたぎとは何関係の用語？',
    options: [
      { optionId: '0', text: '土木関係' },
      { optionId: '1', text: '電気関係' },
      { optionId: '2', text: '海洋関係' },
      { optionId: '3', text: '機械関係' },
      { optionId: '4', text: 'IT関係' },
    ],
  },
  {
    quizId: '6',
    question:
      '羽川翼が二年生一学期の期末テストで唯一落とした穴埋め問題、その教科は？',
    options: [
      { optionId: '0', text: '日本史' },
      { optionId: '1', text: '世界史' },
      { optionId: '2', text: '数学' },
      { optionId: '3', text: '物理' },
      { optionId: '4', text: '国語' },
    ],
  },
  {
    quizId: '7',
    question: '戦場ヶ原ひたぎ、羽川翼、神原駿河達が通っていた中学校は？',
    options: [
      { optionId: '0', text: '公立清風中学校' },
      { optionId: '1', text: '公立七百一中学校' },
      { optionId: '2', text: '私立栂の木二中学校' },
      { optionId: '3', text: '私立直江津中学校' },
      { optionId: '4', text: '公立海維中学校' },
    ],
  },
  {
    quizId: '8',
    question:
      '阿良々木暦が歯を気遣うようになったきっかけである、永久歯の虫歯の治療を受けたのはいつ？',
    options: [
      { optionId: '0', text: '中学一年生の頃' },
      { optionId: '1', text: '小学三年生の頃' },
      { optionId: '2', text: '小学五年生の頃' },
      { optionId: '3', text: '中学三年生の頃' },
      { optionId: '4', text: '高校二年生の頃' },
    ],
  },
  {
    quizId: '9',
    question: '私立直江津高校、阿良々木暦達の担任は？',
    options: [
      { optionId: '0', text: '保科先生' },
      { optionId: '1', text: '春上先生' },
      { optionId: '2', text: '吉城先生' },
      { optionId: '3', text: '島先生' },
      { optionId: '4', text: '入中先生' },
    ],
  },
  {
    quizId: '10',
    question: '私立直江津高校、保健の先生は？',
    options: [
      { optionId: '0', text: '春上先生' },
      { optionId: '1', text: '保科先生' },
      { optionId: '2', text: '吉城先生' },
      { optionId: '3', text: '島先生' },
      { optionId: '4', text: '入中先生' },
    ],
  },
  {
    quizId: '11',
    question: 'おもし蟹によって重みを失った、戦場ヶ原ひたぎの体重は？',
    options: [
      { optionId: '0', text: '五キロ' },
      { optionId: '1', text: '五百グラム' },
      { optionId: '2', text: '二キロ' },
      { optionId: '3', text: '十キロ' },
      { optionId: '4', text: '零グラム' },
    ],
  },
  {
    quizId: '12',
    question: '戦場ヶ原ひたぎが重し蟹に出会ったのは？',
    options: [
      { optionId: '0', text: '中学校を卒業して、高校に入る前' },
      { optionId: '1', text: '小学校を卒業して、中学校に入る前' },
      { optionId: '2', text: '中学校に入ってすぐ' },
      { optionId: '3', text: '中学校を卒業する直前' },
      { optionId: '4', text: '高校に入ってすぐ' },
    ],
  },
  {
    quizId: '13',
    question:
      'ひたぎクラブ、戦場ヶ原ひたぎの台詞より問題です。\n「私には重さがない──私には重みがない。重みというものが、一切ない。全く困ったものじゃない。さながら『○○』といった有様よ。高橋葉介、好きかしら」\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'ヨウスケの奇妙な世界' },
      { optionId: '1', text: 'クレイジーピエロ' },
      { optionId: '2', text: '夢幻紳士' },
      { optionId: '3', text: '我楽多街奇譚' },
      { optionId: '4', text: '学校怪談' },
    ],
  },
  {
    quizId: '14',
    question: '原作において、私立直江津高校の校長先生は？',
    options: [
      { optionId: '0', text: '吉城先生' },
      { optionId: '1', text: '春上先生' },
      { optionId: '2', text: '保科先生' },
      { optionId: '3', text: '島先生' },
      { optionId: '4', text: '入中先生' },
    ],
  },
  {
    quizId: '15',
    question: '私立直江津高校の教頭先生は？',
    options: [
      { optionId: '0', text: '島先生' },
      { optionId: '1', text: '春上先生' },
      { optionId: '2', text: '吉城先生' },
      { optionId: '3', text: '保科先生' },
      { optionId: '4', text: '入中先生' },
    ],
  },
  {
    quizId: '16',
    question: '私立直江津高校、三年の学年主任は？',
    options: [
      { optionId: '0', text: '入中先生' },
      { optionId: '1', text: '春上先生' },
      { optionId: '2', text: '吉城先生' },
      { optionId: '3', text: '島先生' },
      { optionId: '4', text: '保科先生' },
    ],
  },
  {
    quizId: '17',
    question:
      'ひたぎクラブより問題です。\n私立直江津高校の教師の中で、唯一戦場ヶ原ひたぎの重みが失われていることを知っているのは？',
    options: [
      { optionId: '0', text: '春上先生' },
      { optionId: '1', text: '保科先生' },
      { optionId: '2', text: '吉城先生' },
      { optionId: '3', text: '島先生' },
      { optionId: '4', text: '入中先生' },
    ],
  },
  {
    quizId: '18',
    question: 'ひたぎクラブより問題です。\n戦場ヶ原が欲しいのは？',
    options: [
      { optionId: '0', text: '沈黙と無関心だけ' },
      { optionId: '1', text: '平穏と安心だけ' },
      { optionId: '2', text: '降伏と服従だけ' },
      { optionId: '3', text: '無視、シカトの徹底だけ' },
      { optionId: '4', text: '金(きん)と金(かね)' },
    ],
  },
  {
    quizId: '19',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎの綴じたホッチキスの音は？',
    options: [
      { optionId: '0', text: 'かじゃこっ' },
      { optionId: '1', text: 'かしゃん' },
      { optionId: '2', text: 'がしゃっ' },
      { optionId: '3', text: 'ぢっじゃっ' },
      { optionId: '4', text: 'ぎゅしゅぐ' },
    ],
  },
  {
    quizId: '20',
    question:
      'ひたぎクラブより問題です。\n口を綴じられた阿良々木暦には、ホッチキスが何のように見えている？',
    options: [
      { optionId: '0', text: 'マグナム弾' },
      { optionId: '1', text: '刃物' },
      { optionId: '2', text: '不発弾' },
      { optionId: '3', text: 'まきびし' },
      { optionId: '4', text: 'キラークイーンの爆弾' },
    ],
  },
  {
    quizId: '21',
    question:
      'ひたぎクラブより問題です。\nバナナが好きか嫌いかで言えば好きな羽川、理由として挙げていたのは？',
    options: [
      { optionId: '0', text: '栄養価が高い' },
      { optionId: '1', text: 'おいしい' },
      { optionId: '2', text: '甘い' },
      { optionId: '3', text: '食べやすい' },
      { optionId: '4', text: 'お手頃価格' },
    ],
  },
  {
    quizId: '22',
    question: 'ひたぎクラブより問題です。\n阿良々木君のクラスは何階にある？',
    options: [
      { optionId: '0', text: '4階' },
      { optionId: '1', text: '1階' },
      { optionId: '2', text: '2階' },
      { optionId: '3', text: '3階' },
      { optionId: '4', text: '5階' },
    ],
  },
  {
    quizId: '23',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎが持ち歩いている多数の文房具の内、阿良々木暦が一番デンジャラスだと感じたのは？',
    options: [
      { optionId: '0', text: 'アロンアルファ' },
      { optionId: '1', text: '鋏' },
      { optionId: '2', text: '彫刻刀' },
      { optionId: '3', text: '墨汁' },
      { optionId: '4', text: 'コンパス' },
    ],
  },
  {
    quizId: '24',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎを忍野メメの下へ連れていく際、阿良々木暦は戦場ヶ原ひたぎを心の中でどのようなキャラ属性と評した？',
    options: [
      { optionId: '0', text: 'ツンドラ' },
      { optionId: '1', text: 'ツンデレ' },
      { optionId: '2', text: 'プッツンデレ' },
      { optionId: '3', text: 'ツンドロ' },
      { optionId: '4', text: 'クレバス' },
    ],
  },
  {
    quizId: '25',
    question:
      '私立直江津高校から忍野メメのいる学習塾跡の廃墟まで自転車でどのくらいの時間がかかる？',
    options: [
      { optionId: '0', text: '二十分くらい' },
      { optionId: '1', text: '十分くらい' },
      { optionId: '2', text: '三十分くらい' },
      { optionId: '3', text: '一時間くらい' },
      { optionId: '4', text: '二時間くらい' },
    ],
  },
  {
    quizId: '26',
    question:
      'ひたぎクラブ、戦場ヶ原ひたぎの台詞より問題です。\n「そんな気安く私の言葉に突っ込みを入れないでくれるかしら。さっきから、もう、本当に馴れ馴れしいわ。もしも知らない人に聞かれたら○○だと思われるじゃない」\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'クラスメイト' },
      { optionId: '1', text: '仲良し' },
      { optionId: '2', text: '友達' },
      { optionId: '3', text: '彼氏彼女' },
      { optionId: '4', text: '低学歴少年と、絡まれている可哀想な美少女' },
    ],
  },
  {
    quizId: '27',
    question:
      'ひたぎクラブより問題です。\nもしも戦場ヶ原ひたぎから一分おきに連絡がなかったら、何人のむくつけき仲間が、阿良々木暦の家族を襲撃することになっている？',
    options: [
      { optionId: '0', text: '五千人' },
      { optionId: '1', text: '五百人' },
      { optionId: '2', text: '三千人' },
      { optionId: '3', text: '一万人' },
      { optionId: '4', text: '一億二千万人' },
    ],
  },
  {
    quizId: '28',
    question:
      'ひたぎクラブ、戦場ヶ原ひたぎの台詞より問題です。\n「危険なのかそうでないのか、どっちつかずなのと、似たようなものかしら」\nこれは何という言葉に関しての台詞？',
    options: [
      { optionId: '0', text: '往来危険' },
      { optionId: '1', text: 'バカンス' },
      { optionId: '2', text: 'リスク' },
      { optionId: '3', text: '無難な冒険' },
      { optionId: '4', text: '無農薬' },
    ],
  },
  {
    quizId: '29',
    question:
      'ひたぎクラブ、戦場ヶ原ひたぎの台詞より問題です。\nもしも阿良々木暦が下劣な本性を剥き出しにして強姦したら、戦場ヶ原ひたぎはどのような仕返しを考えている？',
    options: [
      { optionId: '0', text: 'ボーイズラブな仕返し' },
      { optionId: '1', text: '家族への報復' },
      { optionId: '2', text: '学校での悪評被害' },
      { optionId: '3', text: 'ノートの全ページに落書き' },
      { optionId: '4', text: 'ちょっと小粋な命に係わる仕返し' },
    ],
  },
  {
    quizId: '30',
    question:
      'ひたぎクラブより問題です。\n阿良々木暦が戦場ヶ原ひたぎと初めて忍野メメがいる廃ビルへ行ったとき、忍野メメはどこにいた？',
    options: [
      { optionId: '0', text: '四階の階段から一番目の教室' },
      { optionId: '1', text: '四階の階段から二番目の教室' },
      { optionId: '2', text: '四階の階段から三番目の教室' },
      { optionId: '3', text: '三階の階段から一番目の教室' },
      { optionId: '4', text: '三階の階段から二番目の教室' },
    ],
  },
  {
    quizId: '31',
    question:
      '「なんだい。阿良々木くん、今日はまた違う女の子を連れているんだね。きみは会うたんびに違う女の子を連れているなあ──全く、○○だよ」\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'ご同慶の至り' },
      { optionId: '1', text: '流石は鬼の申し子' },
      { optionId: '2', text: 'こ憧憬の至り' },
      { optionId: '3', text: '若気の至り' },
      { optionId: '4', text: '大慶至極' },
    ],
  },
  {
    quizId: '32',
    question: '戦場ヶ原ひたぎの暴言に、悪意はどれだけ含まれている？',
    options: [
      { optionId: '0', text: '九十七キロ' },
      { optionId: '1', text: '五キロ' },
      { optionId: '2', text: '二十キロ' },
      { optionId: '3', text: '七十七キロ' },
      { optionId: '4', text: '百キロ' },
    ],
  },
  {
    quizId: '33',
    question:
      'ひたぎクラブより問題です。\n学習塾跡の廃ビルで、戦場ヶ原ひたぎは、うるさかった阿良々木暦のニックネームを何にすると言った？',
    options: [
      { optionId: '0', text: '生理痛' },
      { optionId: '1', text: '不動の寡黙' },
      { optionId: '2', text: '洋風かぶれ' },
      { optionId: '3', text: 'ランボー' },
      { optionId: '4', text: '馬鹿' },
    ],
  },
  {
    quizId: '34',
    question:
      'ひたぎクラブより問題です。\n忍野メメのもとを訪れた戦場ヶ原ひたぎ、何よりもまず、一番最初に訊いておきたいことは？',
    options: [
      { optionId: '0', text: 'あの子は一体、何？' },
      { optionId: '1', text: 'あの子は一体、誰？' },
      { optionId: '2', text: 'このアロハは、誰？' },
      { optionId: '3', text: 'このアロハは、何？' },
      { optionId: '4', text: '忍野メメってのは、どれ？' },
    ],
  },
  {
    quizId: '35',
    question:
      '忍野メメが吸血鬼の成れの果てを忍野忍と名付ける際、最後まで悩んだもう一つの候補は？',
    options: [
      { optionId: '0', text: '忍野お志乃' },
      { optionId: '1', text: '忍野桃' },
      { optionId: '2', text: '忍野汐' },
      { optionId: '3', text: '忍野光雫' },
      { optionId: '4', text: '忍野メアリー' },
    ],
  },
  {
    quizId: '36',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎは父方のお祖母ちゃんから、何とよく言われていたと言っている？',
    options: [
      { optionId: '0', text: '淡泊でもいい、わくましく育ってくれれば' },
      { optionId: '1', text: '多少ヤムチャでも、元気に育ってくれれば' },
      { optionId: '2', text: '位派に建やかに育ってほしい' },
      { optionId: '3', text: '好き嫌いのない、健康な子になってほしい' },
      {
        optionId: '4',
        text: '日照りの時は涙を流し、寒さの夏はおろおろ歩く、そういう人になってほしい',
      },
    ],
  },
  {
    quizId: '37',
    question: '戦場ヶ原ひたぎを騙した詐欺師、全部で何人？',
    options: [
      { optionId: '0', text: '五人' },
      { optionId: '1', text: '一人' },
      { optionId: '2', text: '二人' },
      { optionId: '3', text: '三人' },
      { optionId: '4', text: '四人' },
    ],
  },
  {
    quizId: '38',
    question: '民倉荘は築何年の木造アパート？',
    options: [
      { optionId: '0', text: '築三十年' },
      { optionId: '1', text: '築十年' },
      { optionId: '2', text: '築二十年' },
      { optionId: '3', text: '築四十年' },
      { optionId: '4', text: '築五十年' },
    ],
  },
  {
    quizId: '39',
    question: '戦場ヶ原の住んでいる民倉荘は、最寄りのバス停までどのくらい？',
    options: [
      { optionId: '0', text: '徒歩二十分' },
      { optionId: '1', text: '徒歩十分' },
      { optionId: '2', text: '徒歩三十分' },
      { optionId: '3', text: '自転車で二十分' },
      { optionId: '4', text: '自転車で三十分' },
    ],
  },
  {
    quizId: '40',
    question: '戦場ヶ原が住んでいるのは民倉荘の何号室？',
    options: [
      { optionId: '0', text: '二○一号室' },
      { optionId: '1', text: '二○二号室' },
      { optionId: '2', text: '二○三号室' },
      { optionId: '3', text: '二○四号室' },
      { optionId: '4', text: '二○五号室' },
    ],
  },
  {
    quizId: '41',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎの重みを失わせた怪異、おもし蟹はどこの民間伝承？',
    options: [
      { optionId: '0', text: '九州の山間あたり' },
      { optionId: '1', text: '四国の山間辺り' },
      { optionId: '2', text: '東北の山間辺り' },
      { optionId: '3', text: '本州各地' },
      { optionId: '4', text: '北海道東部の海沿い' },
    ],
  },
  {
    quizId: '42',
    question:
      'ひたぎクラブより問題です。\n次の内、戦場ヶ原ひたぎの重みを失わせた怪異として、正しくないのは？',
    options: [
      { optionId: '0', text: '重石石' },
      { optionId: '1', text: 'おもし蟹' },
      { optionId: '2', text: '重いし蟹' },
      { optionId: '3', text: '重石蟹' },
      { optionId: '4', text: 'おもいし神' },
    ],
  },
  {
    quizId: '43',
    question:
      'ひたぎクラブより問題です。\n忍野メメが怪異について戦場ヶ原ひたぎに語った際、戦場ヶ原ひたぎは忍野メメの発言を、まるで何のようだと言った？',
    options: [
      { optionId: '0', text: '禅問答' },
      { optionId: '1', text: '神道' },
      { optionId: '2', text: '修験道' },
      { optionId: '3', text: '陰陽道' },
      { optionId: '4', text: '歴道' },
    ],
  },
  {
    quizId: '44',
    question:
      '不思議な老人に若者が影を売るという海外の昔話を、忍野メメが語ったエピソードは？',
    options: [
      { optionId: '0', text: 'ひたぎクラブ' },
      { optionId: '1', text: 'まよいマイマイ' },
      { optionId: '2', text: 'するがモンキー' },
      { optionId: '3', text: 'なでこスネイク' },
      { optionId: '4', text: 'つばさキャット' },
    ],
  },
  {
    quizId: '45',
    question: '忍野メメが最も憎む、低俗な言葉は？',
    options: [
      { optionId: '0', text: '命は平等' },
      { optionId: '1', text: '命はお金より尊い' },
      { optionId: '2', text: '命に勝る宝なし' },
      { optionId: '3', text: '友情よりも愛情' },
      { optionId: '4', text: '漫画を読むと馬鹿になる' },
    ],
  },
  {
    quizId: '46',
    question:
      'ひたぎクラブより問題です。\nおもし蟹に関して、戦場ヶ原ひたぎが忍野メメに力を借りた際の対価として要求された金額は？',
    options: [
      { optionId: '0', text: '十万円' },
      { optionId: '1', text: '五万円' },
      { optionId: '2', text: '二十万円' },
      { optionId: '3', text: '百万円' },
      { optionId: '4', text: '五百万円' },
    ],
  },
  {
    quizId: '47',
    question:
      '阿良々木暦が吸血鬼関連で忍野メメに力を貸してもらった際、対価として要求された金額は？',
    options: [
      { optionId: '0', text: '五百万円' },
      { optionId: '1', text: '五万円' },
      { optionId: '2', text: '十万円' },
      { optionId: '3', text: '二十万円' },
      { optionId: '4', text: '百万円' },
    ],
  },
  {
    quizId: '48',
    question:
      '戦場ヶ原ひたぎの裸を見た阿良々木暦は、感想を求められて何といった？',
    options: [
      { optionId: '0', text: 'いい身体してるね' },
      { optionId: '1', text: '僕に感想を求めるな' },
      { optionId: '2', text: '僕の想像と違う' },
      { optionId: '3', text: '男好きのする素敵なボディだな' },
      { optionId: '4', text: '引き締まってて……エロいな' },
    ],
  },
  {
    quizId: '49',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎが思う、この奇妙な世界にひょっとしたらいてくれるかもしれないと思うのは？',
    options: [
      { optionId: '0', text: '峠弥勒' },
      { optionId: '1', text: '夢幻魔実也' },
      { optionId: '2', text: '九段九鬼子' },
      { optionId: '3', text: '山岸涼一' },
      { optionId: '4', text: '加護女' },
    ],
  },
  {
    quizId: '50',
    question:
      '戦場ヶ原ひたぎは、今度生まれ変わるなら、何になりたいと言っている？',
    options: [
      { optionId: '0', text: 'クルル曹長' },
      { optionId: '1', text: 'ドロロ兵長' },
      { optionId: '2', text: 'ケロロ軍曹' },
      { optionId: '3', text: 'ギロロ伍長' },
      { optionId: '4', text: '戦場ヶ原ひたぎ' },
    ],
  },
  {
    quizId: '51',
    question: '戦場ヶ原ひたぎの偏差値は？',
    options: [
      { optionId: '0', text: '七十四' },
      { optionId: '1', text: '六十三' },
      { optionId: '2', text: '六十九' },
      { optionId: '3', text: '七十八' },
      { optionId: '4', text: '八十二' },
    ],
  },
  {
    quizId: '52',
    question: '阿良々木暦の偏差値は？',
    options: [
      { optionId: '0', text: '四十六' },
      { optionId: '1', text: '三十五' },
      { optionId: '2', text: '四十一' },
      { optionId: '3', text: '五十二' },
      { optionId: '4', text: '六十' },
    ],
  },
  {
    quizId: '53',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎは、偏差値チェックの結果、阿良々木暦に今後どのくらい離れろと言った？',
    options: [
      { optionId: '0', text: '半径二万キロ以内に近寄るな' },
      { optionId: '1', text: '半径二メートル以内に近寄るな' },
      { optionId: '2', text: '半径二十メートル以内に近寄るな' },
      { optionId: '3', text: '半径二キロ以内に近寄るな' },
      { optionId: '4', text: '半径二百キロ以内に近寄るな' },
    ],
  },
  {
    quizId: '54',
    question:
      'ひたぎクラブより問題です。\n戦場ヶ原ひたぎと阿良々木暦が身を清めて学習塾跡の廃墟へ再度訪れた際、忍野メメの服装は何になっていた？',
    options: [
      { optionId: '0', text: '浄衣' },
      { optionId: '1', text: '重服' },
      { optionId: '2', text: '狩衣' },
      { optionId: '3', text: '袍袴' },
      { optionId: '4', text: '燕尾服' },
    ],
  },
  {
    quizId: '55',
    question:
      'ひたぎクラブより問題です。\nおもし蟹に重みを返してもらうために、用意した場は廃ビルの何階？',
    options: [
      { optionId: '0', text: '三階' },
      { optionId: '1', text: '一階' },
      { optionId: '2', text: '二階' },
      { optionId: '3', text: '四階' },
      { optionId: '4', text: '五階' },
    ],
  },
  {
    quizId: '56',
    question: '戦場ヶ原ひたぎの誕生日は？',
    options: [
      { optionId: '0', text: '七月七日' },
      { optionId: '1', text: '四月四日' },
      { optionId: '2', text: '五月五日' },
      { optionId: '3', text: '六月六日' },
      { optionId: '4', text: '八月八日' },
    ],
  },
  {
    quizId: '57',
    question: '戦場ヶ原ひたぎの一番好きな小説家は？',
    options: [
      { optionId: '0', text: '夢野久作' },
      { optionId: '1', text: '黒岩涙香' },
      { optionId: '2', text: '木々高太郎' },
      { optionId: '3', text: '小酒井不木' },
      { optionId: '4', text: '江戸川乱歩' },
    ],
  },
  {
    quizId: '58',
    question:
      'ひたぎクラブより問題です。\nおもし蟹に降りてきてもらうために、忍野メメが戦場ヶ原ひたぎにした質問でないのは？',
    options: [
      { optionId: '0', text: '好きな現代音楽は？' },
      { optionId: '1', text: '通っている学校は？' },
      { optionId: '2', text: '子供の頃の失敗談を聞かせてくれる？' },
      { optionId: '3', text: '小学校を卒業するとき、どう思った？' },
      { optionId: '4', text: '初恋の男の子はどんな子だった？' },
    ],
  },
  {
    quizId: '59',
    question:
      '中学生の時、戦場ヶ原ひたぎは宗教団体の幹部の人に犯されそうになったとき、近くにあった何で幹部の人をなぐった？',
    options: [
      { optionId: '0', text: 'スパイク' },
      { optionId: '1', text: '辞書' },
      { optionId: '2', text: 'バトン' },
      { optionId: '3', text: 'ダンベル' },
      { optionId: '4', text: 'レンチ' },
    ],
  },
  {
    quizId: '60',
    question:
      '戦場ヶ原ひたぎの母親が悪徳宗教に嵌ったのは、戦場ヶ原ひたぎが何年生のとき？',
    options: [
      { optionId: '0', text: '小学五年生' },
      { optionId: '1', text: '小学一年生' },
      { optionId: '2', text: '小学三年生' },
      { optionId: '3', text: '中学一年生' },
      { optionId: '4', text: '中学三年生' },
    ],
  },
  {
    quizId: '61',
    question: '阿良々木暦の体重は？',
    options: [
      { optionId: '0', text: '五十五キロ' },
      { optionId: '1', text: '四十五キロ' },
      { optionId: '2', text: '五十キロ' },
      { optionId: '3', text: '六十キロ' },
      { optionId: '4', text: '六十五キロ' },
    ],
  },
  {
    quizId: '62',
    question:
      '原作、まよいマイマイより問題です。\n八九寺と遭遇した母の日は何月何日？',
    options: [
      { optionId: '0', text: '五月十四日' },
      { optionId: '1', text: '五月十日' },
      { optionId: '2', text: '五月十一日' },
      { optionId: '3', text: '五月十二日' },
      { optionId: '4', text: '五月十三日' },
    ],
  },
  {
    quizId: '63',
    question: '原作において、浪白公園に設置されている遊具は？',
    options: [
      { optionId: '0', text: 'ブランコ' },
      { optionId: '1', text: 'シーソー' },
      { optionId: '2', text: 'ジャングルジム' },
      { optionId: '3', text: '滑り台' },
      { optionId: '4', text: '鉄棒' },
    ],
  },
  {
    quizId: '64',
    question: '母の日の戦場ヶ原ひたぎはどのような髪型だった？',
    options: [
      { optionId: '0', text: 'ポニーテイル' },
      { optionId: '1', text: 'ツインテイル' },
      { optionId: '2', text: 'ストレート' },
      { optionId: '3', text: '三つ編み' },
      { optionId: '4', text: 'ウェーブパーマ' },
    ],
  },
  {
    quizId: '65',
    question:
      '戦場ヶ原ひたぎの中で、次世代を担うセンシティブな言葉として期待が集まっているのは？',
    options: [
      { optionId: '0', text: '蕩れ' },
      { optionId: '1', text: '萌え' },
      { optionId: '2', text: '茲る' },
      { optionId: '3', text: '葢う' },
      { optionId: '4', text: '蘯' },
    ],
  },
  {
    quizId: '66',
    question:
      '原作において、母の日に公園で何をしているのかと、戦場ヶ原ひたぎに尋ねられた阿良々木暦は、最初になんと答えた？',
    options: [
      { optionId: '0', text: '暇潰し' },
      { optionId: '1', text: 'ツーリング' },
      { optionId: '2', text: 'なんでもない' },
      { optionId: '3', text: '散歩' },
      { optionId: '4', text: 'ドライブ' },
    ],
  },
  {
    quizId: '67',
    question: '高校生、マウンテンバイク、中学生、バタフライナイフ。小学生は？',
    options: [
      { optionId: '0', text: 'スカートめくり' },
      { optionId: '1', text: 'キンケシ' },
      { optionId: '2', text: 'ランドセル' },
      { optionId: '3', text: 'ローラースルーゴーゴー' },
      { optionId: '4', text: 'ナップサック' },
    ],
  },
  {
    quizId: '68',
    question: '原作より問題です。\n浪白公園のベンチは何人掛け？',
    options: [
      { optionId: '0', text: '4人掛け' },
      { optionId: '1', text: '1人掛け' },
      { optionId: '2', text: '2人掛け' },
      { optionId: '3', text: '3人掛け' },
      { optionId: '4', text: '5人掛け' },
    ],
  },
  {
    quizId: '69',
    question:
      'おもし蟹の件で阿良々木暦にお返しをしようとした戦場ヶ原ひたぎ、その際に彼女が例として提案したエロ方面の願いに無かったものは？',
    options: [
      { optionId: '0', text: '一週間無駄毛を処理する様子を観察させて欲しい' },
      { optionId: '1', text: '一週間語尾に『にゅ』とつけて会話して欲しい' },
      { optionId: '2', text: '一週間下着を着用せずに授業を受けて欲しい' },
      { optionId: '3', text: '一週間毎朝裸エプロンで起こしに来て欲しい' },
      { optionId: '4', text: '一週間浣腸ダイエットに付き合って欲しい' },
    ],
  },
  {
    quizId: '70',
    question: '阿良々木火憐と阿良々木月火、二人あわせて？',
    options: [
      { optionId: '0', text: '栂の木二中のファイヤーシスターズ' },
      { optionId: '1', text: 'リトルシスターズ' },
      { optionId: '2', text: '七百一中のファイヤーシスターズ' },
      { optionId: '3', text: '栂の木二中のフレイムシスターズ' },
      { optionId: '4', text: '七百一中のフレイムシスターズ' },
    ],
  },
  {
    quizId: '71',
    question: 'まよいマイマイより問題です。\n阿良々木暦のしょぼさとは？',
    options: [
      {
        optionId: '0',
        text: '大吉を引き当てはしたものの、よく読むと内容的にはそんないいことも書いていない',
      },
      { optionId: '1', text: 'おみくじで小吉ばかり引く' },
      { optionId: '2', text: 'おみくじで大凶ばかり引く' },
      { optionId: '3', text: '白紙のおみくじを引く' },
      {
        optionId: '4',
        text: '大吉を引き当てはしたものの、プリントミスで内容がよく読めない',
      },
    ],
  },
  {
    quizId: '72',
    question: '姉妹逆縁婚の略称は？',
    options: [
      { optionId: '0', text: 'ソロコン' },
      { optionId: '1', text: 'レビコン' },
      { optionId: '2', text: 'トクコン' },
      { optionId: '3', text: 'シスコン' },
      { optionId: '4', text: 'リルコン' },
    ],
  },
  {
    quizId: '73',
    question:
      'まよいマイマイより問題です。\nおもし蟹の件についての、戦場ヶ原ひたぎから阿良々木暦へのお返し、最終的にどう落ち着いた？',
    options: [
      { optionId: '0', text: 'ジュースでもおごる' },
      { optionId: '1', text: '彼女ができる' },
      { optionId: '2', text: '勉強を教える' },
      { optionId: '3', text: '友達になる' },
      { optionId: '4', text: '一万円を払う' },
    ],
  },
  {
    quizId: '74',
    question:
      '八九寺真宵のリュックサックに縫われている名札によると、八九寺真宵のクラスは？',
    options: [
      { optionId: '0', text: '五年三組' },
      { optionId: '1', text: '五年一組' },
      { optionId: '2', text: '五年二組' },
      { optionId: '3', text: '五年四組' },
      { optionId: '4', text: '五年五組' },
    ],
  },
  {
    quizId: '75',
    question: '阿良々木暦は『八九寺』を初め何と読んだ？',
    options: [
      { optionId: '0', text: 'やくでら' },
      { optionId: '1', text: 'はちくじ' },
      { optionId: '2', text: 'やくじ' },
      { optionId: '3', text: 'はくでら' },
      { optionId: '4', text: 'はきゅうじ' },
    ],
  },
  {
    quizId: '76',
    question: '八九寺真宵の初台詞は？',
    options: [
      {
        optionId: '0',
        text: '話しかけないでください。あなたのことが嫌いです。',
      },
      { optionId: '1', text: 'な、何をするんですかっ！' },
      { optionId: '2', text: '迅速にどっか行っちゃってくださいっ！' },
      { optionId: '3', text: '綱手さんの家を探しています' },
      { optionId: '4', text: '臭いですっ！　近寄らないでくださいっ！' },
    ],
  },
  {
    quizId: '77',
    question:
      'まよいマイマイより問題です。\n八九寺真宵は初対面の時点で、何故阿良々木暦を嫌っていたと言っている？',
    options: [
      { optionId: '0', text: '前世からの因縁' },
      { optionId: '1', text: '阿呆毛が気に入らなかったから' },
      {
        optionId: '2',
        text: '日曜日の公園で一人たたずんでいるなんて、危ない人間に違いないから',
      },
      { optionId: '3', text: 'なんとなく' },
      { optionId: '4', text: '人見知りだから' },
    ],
  },
  {
    quizId: '78',
    question:
      'まよいマイマイより問題です。\n公園前にいた迷子の八九寺真宵に、力になれるかと思って話しかけた阿良々木暦、取っ組み合いの喧嘩をしたのは何故？',
    options: [
      { optionId: '0', text: '戦士と戦士の魂が呼応したから' },
      { optionId: '1', text: '人間は戦い合うものだから' },
      { optionId: '2', text: 'よく分からない' },
      { optionId: '3', text: '男子高校生と女子小学生だから' },
      { optionId: '4', text: '遺伝子が惹かれあったから' },
    ],
  },
  {
    quizId: '79',
    question: 'PTAとは何という医学用語の略？',
    options: [
      { optionId: '0', text: '経皮経管的血管形成術' },
      { optionId: '1', text: '大動脈弁輪拡張症' },
      { optionId: '2', text: '肺動脈絞扼術' },
      { optionId: '3', text: '動脈管開存症' },
      { optionId: '4', text: '圧迫包装' },
    ],
  },
  {
    quizId: '80',
    question: '八九寺真宵の母親の苗字は？',
    options: [
      { optionId: '0', text: '綱手' },
      { optionId: '1', text: '八九寺' },
      { optionId: '2', text: '大輪' },
      { optionId: '3', text: '五雑' },
      { optionId: '4', text: '右巻' },
    ],
  },
  {
    quizId: '81',
    question: '八九寺真宵が初めて噛んだ阿良々木さんの名前は？',
    options: [
      { optionId: '0', text: '阿良々々木さん' },
      { optionId: '1', text: '阿良良々木さん' },
      { optionId: '2', text: '阿々良木さん' },
      { optionId: '3', text: 'ありゃりゃ木さん' },
      { optionId: '4', text: '良々々木さん' },
    ],
  },
  {
    quizId: '82',
    question: '八九寺真宵にはバスガス爆発という知り合いが何人ほどいる？',
    options: [
      { optionId: '0', text: '三人' },
      { optionId: '1', text: '一人' },
      { optionId: '2', text: '二人' },
      { optionId: '3', text: '四人' },
      { optionId: '4', text: '五人' },
    ],
  },
  {
    quizId: '83',
    question: '夢を食べる動物はっ？',
    options: [
      { optionId: '0', text: '人間' },
      { optionId: '1', text: '獏' },
      { optionId: '2', text: '虫' },
      { optionId: '3', text: '兎' },
      { optionId: '4', text: 'そんなものはいない' },
    ],
  },
  {
    quizId: '84',
    question:
      '戦場ヶ原ひたぎが中学生のときに、七歳くらいの子供にぶつかり、下手に出てしまった場所は？',
    options: [
      { optionId: '0', text: 'デパート' },
      { optionId: '1', text: '本屋' },
      { optionId: '2', text: 'スーパー' },
      { optionId: '3', text: 'コンビニ' },
      { optionId: '4', text: 'とある道' },
    ],
  },
  {
    quizId: '85',
    question: '「名は体を表す」\n体の意味は？',
    options: [
      { optionId: '0', text: '本体' },
      { optionId: '1', text: '肉体' },
      { optionId: '2', text: '外観' },
      { optionId: '3', text: '中身' },
      { optionId: '4', text: '体系' },
    ],
  },
  {
    quizId: '86',
    question:
      'まよいマイマイより問題です。\n戦場ヶ原ひたぎがGPSのナビゲーションシステムを使おうとしたら、どうなった？',
    options: [
      { optionId: '0', text: '圏外になった' },
      { optionId: '1', text: 'GPSの強制終了' },
      { optionId: '2', text: '携帯電話が大破された' },
      { optionId: '3', text: 'でたらめな位置情報の表示された' },
      { optionId: '4', text: '携帯電話の電源が切れた' },
    ],
  },
  {
    quizId: '87',
    question: '八九寺真宵が小学四年生のときの苗字は？',
    options: [
      { optionId: '0', text: '八九寺' },
      { optionId: '1', text: '綱手' },
      { optionId: '2', text: '大輪' },
      { optionId: '3', text: '五雑' },
      { optionId: '4', text: '右巻' },
    ],
  },
  {
    quizId: '88',
    question:
      'まよいマイマイ、羽川翼の台詞より問題です。\n「○○っていうのが、なんていうか、自分の住んでいる土地の文化レベルの低さを表してるみたいで、あは、やになっちゃうよね」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '図書館が日曜日に休み' },
      { optionId: '1', text: '大きな書店が一店舗しかない' },
      { optionId: '2', text: 'バスが一時間に一本しかない' },
      { optionId: '3', text: '昔ながらの信仰が続いている' },
      { optionId: '4', text: '散歩していて人と出会わない' },
    ],
  },
  {
    quizId: '89',
    question:
      '羽川翼に\n「やおい？　何それ」\nと尋ねられた阿良々木暦は、『やおい』を何と説明した？',
    options: [
      { optionId: '0', text: 'ヤマなしオチなし意味深長の頭文字だ' },
      { optionId: '1', text: 'ヤマなしオチなしイミなしの頭文字だ' },
      { optionId: '2', text: 'ヤマなしオチなし忌み嫌うの頭文字だ' },
      { optionId: '3', text: 'ヤマありオチありイミありの頭文字だ' },
      { optionId: '4', text: 'グルタミン酸受容体のことだ' },
    ],
  },
  {
    quizId: '90',
    question:
      'まよいマイマイより問題です。\n阿良々木暦のクラスで明日行われる小テストは？',
    options: [
      { optionId: '0', text: '歴史' },
      { optionId: '1', text: '世界史' },
      { optionId: '2', text: '数学' },
      { optionId: '3', text: '日本史' },
      { optionId: '4', text: '英語' },
    ],
  },
  {
    quizId: '91',
    question: '阿良々木暦が戦場ヶ原ひたぎの携帯番号を入手した時刻は？',
    options: [
      { optionId: '0', text: '五月十四日、日曜日、十四時十五分三十秒' },
      { optionId: '1', text: '五月十四日、日曜日、十二時二十五分四十秒' },
      { optionId: '2', text: '五月十四日、日曜日、十三時四十分十五秒' },
      { optionId: '3', text: '五月十日、日曜日、十二時二十五分四十秒' },
      { optionId: '4', text: '五月十日、日曜日、十三時四十分十五秒' },
    ],
  },
  {
    quizId: '92',
    question: 'まよいマイマイより問題です。\n忍野メメの中学生の頃からの夢は？',
    options: [
      { optionId: '0', text: '可愛い女子高生に起こしてもらうこと' },
      { optionId: '1', text: '可愛い女の子に起こしてもらうこと' },
      { optionId: '2', text: '誰かに優しく起こしてもらうこと' },
      { optionId: '3', text: '可愛い女子中学生に起こしてもらうこと' },
      { optionId: '4', text: '誰にも邪魔されずに安眠すること' },
    ],
  },
  {
    quizId: '93',
    question: '忍野メメ、羽川翼が八九寺という苗字から思い浮べた作品は？',
    options: [
      { optionId: '0', text: '東雲物語' },
      { optionId: '1', text: '大鏡' },
      { optionId: '2', text: '雨月物語' },
      { optionId: '3', text: '史記' },
      { optionId: '4', text: '源氏物語' },
    ],
  },
  {
    quizId: '94',
    question:
      'まよいマイマイより問題です。\n戦場ヶ原ひたぎが忍野メメのもとで取り出した文房具は？',
    options: [
      { optionId: '0', text: 'ホッチキス' },
      { optionId: '1', text: 'カッターナイフ' },
      { optionId: '2', text: 'シャープペンシル' },
      { optionId: '3', text: '鋏' },
      { optionId: '4', text: 'コンパス' },
    ],
  },
  {
    quizId: '95',
    question:
      'まよいマイマイ、忍野メメの台詞より問題です。\n「綱手？　へえ、綱手かよ……よりにもよって。よりにもよって――糸がよれ過ぎだぜ。完全にほつれちまってる。因縁にしたって、そりゃさすがに出来過ぎだなあ、おい。○○感じだぜ。八九寺に綱手……なるほど、それで真宵か」\n○○に入ることわざは？',
    options: [
      { optionId: '0', text: '籌を帷幄の中に運らし勝ちを千里の外に決する' },
      { optionId: '1', text: '蝸牛角上の争いをする' },
      { optionId: '2', text: '蜂の巣をつついたような' },
      { optionId: '3', text: '平仄が合わない' },
      { optionId: '4', text: '玉磨かざれば器を成\nらざる' },
    ],
  },
  {
    quizId: '96',
    question: '「大人の男は、謝らない」\nそれは何故？',
    options: [
      { optionId: '0', text: '魂の価値が、下がるから' },
      { optionId: '1', text: '人間強度が、下がるから' },
      { optionId: '2', text: '格好悪いから' },
      { optionId: '3', text: '大人で、男だから' },
      { optionId: '4', text: '謝りたくないから' },
    ],
  },
  {
    quizId: '97',
    question:
      'まよいマイマイ、八九寺真宵の台詞より問題です。\n「盗人猛々しいとはこのことです……もう本気で怒りました…温厚なわたしですが、○○っ！」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '仏の顔もサンドバッグです' },
      { optionId: '1', text: '給料袋の緒が切れました' },
      { optionId: '2', text: '大智は愚の如月です' },
      { optionId: '3', text: '三度目の掃除機' },
      { optionId: '4', text: '兎も七日なぶれば噛みまむよ' },
    ],
  },
  {
    quizId: '98',
    question:
      'まよいマイマイより問題です。\n八九寺真宵の形式的に美しい部位は？',
    options: [
      { optionId: '0', text: '二の腕' },
      { optionId: '1', text: 'ふくらはぎ' },
      { optionId: '2', text: '太もも' },
      { optionId: '3', text: '鎖骨' },
      { optionId: '4', text: '髪型' },
    ],
  },
  {
    quizId: '99',
    question: '戦場ヶ原ひたぎが阿良々木暦にした告白は？',
    options: [
      { optionId: '0', text: 'I love you' },
      { optionId: '1', text: '好きです、結婚してください' },
      { optionId: '2', text: '付き合ってください' },
      { optionId: '3', text: 'I need you' },
      { optionId: '4', text: 'Love me do' },
    ],
  },
  {
    quizId: '100',
    question:
      'まよいマイマイより問題です。\n母の日である今日本日この日、阿良々木家の夕飯の当番は？',
    options: [
      { optionId: '0', text: '暦' },
      { optionId: '1', text: '火憐' },
      { optionId: '2', text: '月火' },
      { optionId: '3', text: '父' },
      { optionId: '4', text: '母' },
    ],
  },
  {
    quizId: '101',
    question:
      '母の日に家を抜け出した阿良々木暦は、帰ってから、火憐と月火にどのような約束をした？',
    options: [
      { optionId: '0', text: '来年の母の日は家の敷地内から絶対に出ない' },
      { optionId: '1', text: '宿題を代わりに終わらせる' },
      { optionId: '2', text: '何でも一つ言うことを聞く' },
      { optionId: '3', text: '父の日は家の敷地内から絶対に出ない' },
      { optionId: '4', text: '誕生日には言うことを聞いて、皆で一緒に祝う' },
    ],
  },
  {
    quizId: '102',
    question:
      '阿良々木暦と戦場ヶ原ひたぎの関係を、初めに八九寺真宵は何と表現した？',
    options: [
      { optionId: '0', text: '恋愛契約' },
      { optionId: '1', text: '恋愛取引' },
      { optionId: '2', text: '男女交際' },
      { optionId: '3', text: 'カップル' },
      { optionId: '4', text: '合意的恋仲' },
    ],
  },
  {
    quizId: '103',
    question:
      'するがモンキーより問題です。\n阿良々木暦が神原駿河に向けて言った、思いつきそうでなかなか思いつきそうにない、見事に状況に即した一言は？',
    options: [
      { optionId: '0', text: 'こんな仕組まれた奇遇がありえるか' },
      {
        optionId: '1',
        text: 'お前の辞書の中には奇遇という文字の説明がないのか!?',
      },
      { optionId: '2', text: '必然的な奇遇だな' },
      { optionId: '3', text: 'お前はギャルゲーのキャラクターか何かなのか' },
      { optionId: '4', text: 'こんな邂逅が起こりうるか' },
    ],
  },
  {
    quizId: '104',
    question:
      'するがモンキーより問題です。\n「放課後は部活なんじゃないのかよ」\nと指摘した阿良々木暦に対し、神原駿河は阿良々木暦の鋭さには何だって裸足で逃げ出すだろうと言っている？',
    options: [
      { optionId: '0', text: 'フィリップ・マーロウ' },
      { optionId: '1', text: 'シャーロック・ホームズ' },
      { optionId: '2', text: 'エルキュール・ポワロ' },
      { optionId: '3', text: 'エラリー・クイーン' },
      { optionId: '4', text: '江戸川コナン' },
    ],
  },
  {
    quizId: '105',
    question:
      'するがモンキー、神原駿河の台詞より問題です。\n「阿良々木先輩は本当に思いやりのある人だ。細やかな心配り、痛み入る。実に懐が深い、○○な心具合だぞ」\n○○に入る四字熟語は？',
    options: [
      { optionId: '0', text: '一望千里' },
      { optionId: '1', text: '一瀉千里' },
      { optionId: '2', text: '一日千秋' },
      { optionId: '3', text: '一攫千金' },
      { optionId: '4', text: '一刻千金' },
    ],
  },
  {
    quizId: '106',
    question:
      'するがモンキーより問題です。\n帰宅途中の阿良々木暦に声を掛けてきた神原駿河、阿良々木暦に\n「で、神原。今日は何の用なんだ？」\nと問われて、どのように答えた？',
    options: [
      {
        optionId: '0',
        text: 'ロシアのこれからの政治情勢について、阿良々木先輩の意見を聞きたい',
      },
      {
        optionId: '1',
        text: 'インドのIT関連について、阿良々木先輩の意見を聞きたい',
      },
      {
        optionId: '2',
        text: 'NATO組織の拡大について、阿良々木先輩の意見を聞きたい',
      },
      {
        optionId: '3',
        text: '戦争が与える被害について、阿良々木先輩の意見を聞きたい',
      },
      { optionId: '4', text: '阿良々木先輩に話し掛けるのに用など必要だろうか' },
    ],
  },
  {
    quizId: '107',
    question:
      '「良々々木さん」\n「～略～」\n「失礼。噛みました」\n「違う、わざとだ……」\n「噛みまみた」\n「わざとじゃないっ!?」\n「○○」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '垣間見た' },
      { optionId: '1', text: '神はいた' },
      { optionId: '2', text: 'ファミマ見た？' },
      { optionId: '3', text: 'カミ切れた' },
      { optionId: '4', text: 'まあ、それはともかく、阿良々木さん' },
    ],
  },
  {
    quizId: '108',
    question:
      'するがモンキー、阿良々木暦の台詞より問題です。\n「あのなあ。僕はそういう、何でもかんでも○○で説明しちまう風潮ってのは、あんまり好きじゃないんだよ。」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '恋愛感情' },
      { optionId: '1', text: 'ご都合主義' },
      { optionId: '2', text: '流行' },
      { optionId: '3', text: '責任問題' },
      { optionId: '4', text: 'お金' },
    ],
  },
  {
    quizId: '109',
    question:
      '実力テストに向けての勉強、戦場ヶ原ひたぎが阿良々木暦を見捨てる可能性は？',
    options: [
      { optionId: '0', text: '0.29375' },
      { optionId: '1', text: '0.211805555555556' },
      { optionId: '2', text: '0.252777777777778' },
      { optionId: '3', text: '0.334722222222222' },
      { optionId: '4', text: '0.375694444444444' },
    ],
  },
  {
    quizId: '110',
    question: '阿良々木暦の唯一の得意科目は？',
    options: [
      { optionId: '0', text: '数学' },
      { optionId: '1', text: '世界史' },
      { optionId: '2', text: '日本史' },
      { optionId: '3', text: '物理' },
      { optionId: '4', text: '国語' },
    ],
  },
  {
    quizId: '111',
    question:
      '阿良々木暦が実力テストで赤点を取らないための勉強法、戦場ヶ原ひたぎは、まずどの科目から攻めましょうと言った？',
    options: [
      { optionId: '0', text: '世界史' },
      { optionId: '1', text: '国語' },
      { optionId: '2', text: '物理' },
      { optionId: '3', text: '日本史' },
      { optionId: '4', text: '数学' },
    ],
  },
  {
    quizId: '112',
    question: '上は洪水下は大火事、なーんだ？',
    options: [
      { optionId: '0', text: '神原駿河の家' },
      { optionId: '1', text: '風呂釜' },
      { optionId: '2', text: '神原駿河の部屋' },
      { optionId: '3', text: '神原駿河' },
      { optionId: '4', text: '阿良々木暦の部屋' },
    ],
  },
  {
    quizId: '113',
    question:
      'するがモンキーより問題です。\n「でもね、阿良々木くん。人付き合いが嫌いなのと、人間嫌いは、違うんだよ？」\nの後に、羽川翼が続けた引用は？',
    options: [
      {
        optionId: '0',
        text: '『世の中に 人の来るこそ うるさけれ とは言ふものの お前ではなし』',
      },
      {
        optionId: '1',
        text: '『世の中に 人の来るこそ うれしけれ とは言ふものの お前ではなし』',
      },
      {
        optionId: '2',
        text: '『世の中の 人は何とも 言わば言え 我が成すことは 吾のみぞ知る 』',
      },
      {
        optionId: '3',
        text: '『世の中で一番みにくい事は、他人の生活をうらやむ事です。』',
      },
      {
        optionId: '4',
        text: '『相手を理解できれば\n人間関係のいざこざのほとんどは解決する』',
      },
    ],
  },
  {
    quizId: '114',
    question:
      '阿良々木暦はマウンテンバイクが壊れ、怪我を負った理由を、戦場ヶ原ひたぎに何と説明した？',
    options: [
      {
        optionId: '0',
        text: '電話しながらペダルを漕いでいたら、電柱に激突した',
      },
      { optionId: '1', text: '電話しながらペダルを漕いでいたら、車に轢かれた' },
      {
        optionId: '2',
        text: '電話しながらペダルを漕いでいたら、コンボイに轢かれた',
      },
      {
        optionId: '3',
        text: '電話しながらペダルを漕いでいたら、通り魔に襲われた',
      },
      { optionId: '4', text: '電話しながらペダルを漕いでいたら、塀に激突した' },
    ],
  },
  {
    quizId: '115',
    question: '神原駿河の家は直江津高校から自転車でどのくらいの距離にある？',
    options: [
      { optionId: '0', text: '三十分' },
      { optionId: '1', text: '十分' },
      { optionId: '2', text: '二十分' },
      { optionId: '3', text: '一時間' },
      { optionId: '4', text: '一時間半' },
    ],
  },
  {
    quizId: '116',
    question:
      'するがモンキーより問題です。\n阿良々木暦が初めて神原駿河の部屋を訪れたとき、最初にした要求は？',
    options: [
      { optionId: '0', text: '僕にこの部屋を掃除するための時間をくれ' },
      { optionId: '1', text: '入るだけのスペースを作ってくれ' },
      { optionId: '2', text: '散らばっている衣類を片付けてくれ' },
      { optionId: '3', text: '十分間、部屋を好きにさせてくれ' },
      { optionId: '4', text: '他の部屋に移動しないか' },
    ],
  },
  {
    quizId: '117',
    question: '神原駿河のクラスは？',
    options: [
      { optionId: '0', text: '二年二組' },
      { optionId: '1', text: '二年一組' },
      { optionId: '2', text: '二年三組' },
      { optionId: '3', text: '二年四組' },
      { optionId: '4', text: '二年五組' },
    ],
  },
  {
    quizId: '118',
    question:
      '神原駿河がヴァルハラコンビとは別に考えた、神原個人のニックネームは？',
    options: [
      { optionId: '0', text: 'ガンバルするがちゃん' },
      { optionId: '1', text: '頑張る駿河ちゃん' },
      { optionId: '2', text: 'がんばるスルガちゃん' },
      { optionId: '3', text: 'がんばるするがちゃん' },
      { optionId: '4', text: 'ガンバル駿河ちゃん' },
    ],
  },
  {
    quizId: '119',
    question: '『猿の手』の原作者は？',
    options: [
      { optionId: '0', text: 'ウイリアム・ウイマーク・ジェイソブズ' },
      { optionId: '1', text: 'ポール・アンダースン' },
      { optionId: '2', text: 'クライヴ・バーカー' },
      { optionId: '3', text: 'メフメット・ムラート・ソマー' },
      { optionId: '4', text: 'ヨハン・ウォルフガング・フォン・ゲーテ' },
    ],
  },
  {
    quizId: '120',
    question:
      '神原駿河の家で、\n「私はレズなのだ」\nと神原駿河から告白を受けた阿良々木暦は、どのようにずっこけた？',
    options: [
      { optionId: '0', text: '藤子不二雄先生の漫画みたいにずっこけた' },
      { optionId: '1', text: 'ズッコケ三人組さながらずっこけた' },
      { optionId: '2', text: 'サンタナのようにずっこけた' },
      { optionId: '3', text: '風大左衛門よろしくずっこけた' },
      { optionId: '4', text: '某漫画キャラクターのようにずっこけた' },
    ],
  },
  {
    quizId: '121',
    question:
      'するがモンキー、神原駿河の台詞より問題です。\n「戦場ヶ原先輩は──阿良々木先輩と、朝の教室で、○○と、話していた。中学時代でも私に見せてくれたことがないような、幸せそうな、笑顔でな」\n○○に入る四字熟語は？',
    options: [
      { optionId: '0', text: '喋々喃々' },
      { optionId: '1', text: '二人三脚' },
      { optionId: '2', text: '平々凡々' },
      { optionId: '3', text: '異体同心' },
      { optionId: '4', text: '和気藹々' },
    ],
  },
  {
    quizId: '122',
    question: '神原駿河は忍野メメという名前をどのような名前と言った？',
    options: [
      { optionId: '0', text: 'ニックネームのつけにくそうな名前' },
      { optionId: '1', text: 'さぞかしよく萌えそうな名前' },
      { optionId: '2', text: '可愛らしい名前' },
      { optionId: '3', text: '日本人離れした名前' },
      { optionId: '4', text: '女の子のような名前' },
    ],
  },
  {
    quizId: '123',
    question: '神原駿河の身体を、男好きのする素敵なボディだと評したのは誰？',
    options: [
      { optionId: '0', text: '部活の顧問' },
      { optionId: '1', text: '阿良々木暦' },
      { optionId: '2', text: '戦場ヶ原ひたぎ' },
      { optionId: '3', text: 'お祖父ちゃん' },
      { optionId: '4', text: '男バスのキャプテン' },
    ],
  },
  {
    quizId: '124',
    question:
      'するがモンキー、神原駿河の台詞より問題です。\n「ん、BLとは○○の略だぞ？」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'ボーイズラブ' },
      { optionId: '1', text: 'ボールズラブ' },
      { optionId: '2', text: 'バスケットラブ' },
      { optionId: '3', text: 'ビーストラブ' },
      { optionId: '4', text: 'ブラックリスト' },
    ],
  },
  {
    quizId: '125',
    question:
      '『○○でもあり××でもある、○○だと思う者には○○で、××だと思う者には××だ』って言う台詞が格好いいのはいつまで？',
    options: [
      { optionId: '0', text: '中学生まで' },
      { optionId: '1', text: '小学校低学年まで' },
      { optionId: '2', text: '小学校中学年まで' },
      { optionId: '3', text: '小学校高学年まで' },
      { optionId: '4', text: '現実を知るまで' },
    ],
  },
  {
    quizId: '126',
    question: '忍野メメが主にねぐらにしているのは、廃ビルの何階？',
    options: [
      { optionId: '0', text: '四階' },
      { optionId: '1', text: '一階' },
      { optionId: '2', text: '二階' },
      { optionId: '3', text: '三階の階段から一番目の教室' },
      { optionId: '4', text: '五階' },
    ],
  },
  {
    quizId: '127',
    question:
      'するがモンキーより問題です。\n阿良々木暦が神原駿河と初めて忍野メメがいる廃ビルへ行ったときの神原の台詞。\n「よく言われないか？　○○だと」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '優しくていい人' },
      { optionId: '1', text: '気取らない人' },
      { optionId: '2', text: '童心を忘れない純粋な人' },
      { optionId: '3', text: '夢を持つ素晴らしい人' },
      { optionId: '4', text: '謎の多い男' },
    ],
  },
  {
    quizId: '128',
    question:
      'するがモンキーより問題です。\n阿良々木暦が神原駿河と初めて忍野メメがいる廃ビルへ行ったとき、忍野忍はどこにいた？',
    options: [
      { optionId: '0', text: '三階と四階との間の踊り場' },
      { optionId: '1', text: '玄関' },
      { optionId: '2', text: '一階と二階との間の踊り場' },
      { optionId: '3', text: '二階と三階との間の踊り場' },
      { optionId: '4', text: '三階の階段から二番目の教室' },
    ],
  },
  {
    quizId: '129',
    question: '忍野忍の外見年齢はどのくらい？',
    options: [
      { optionId: '0', text: '八歳くらい' },
      { optionId: '1', text: '五歳くらい' },
      { optionId: '2', text: '十歳くらい' },
      { optionId: '3', text: '十二歳くらい' },
      { optionId: '4', text: '十五歳くらい' },
    ],
  },
  {
    quizId: '130',
    question: '阿良々木暦の好きな色は？',
    options: [
      { optionId: '0', text: '水色' },
      { optionId: '1', text: '赤色' },
      { optionId: '2', text: '黒色' },
      { optionId: '3', text: '紫色' },
      { optionId: '4', text: '黄緑色' },
    ],
  },
  {
    quizId: '131',
    question:
      'するがモンキーより問題です。\n神原駿河を学習塾跡の廃墟へ連れて行ったとき、阿良々木暦に忍野メメは次はどのような髪型の女の子を連れてきて欲しいと言っていた？',
    options: [
      { optionId: '0', text: 'ワンレン' },
      { optionId: '1', text: 'ショートボブ' },
      { optionId: '2', text: '聖子ちゃんカット' },
      { optionId: '3', text: 'ポンパドール' },
      { optionId: '4', text: 'お団子' },
    ],
  },
  {
    quizId: '132',
    question:
      'するがモンキーより問題です。\n「……忍なら階段で見かけたぜ。なんであいつ、あんなところにいるんだ？」\nという阿良々木暦の台詞に対する、忍野メメの台詞\n「涙を呑んで○○は譲ってあげたというのに、いやはや心の狭い忍ちゃんだよ」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'ポン・デ・リング' },
      { optionId: '1', text: 'フレンチクルーラー' },
      { optionId: '2', text: 'ゴールデンチョコレート' },
      { optionId: '3', text: 'D-ポップ' },
      { optionId: '4', text: 'オールドファッション' },
    ],
  },
  {
    quizId: '133',
    question: '私立直江津高校の制服は、学年ごとにどのような違いがある？',
    options: [
      { optionId: '0', text: 'スカーフの色が違う' },
      { optionId: '1', text: 'スカートの色が違う' },
      { optionId: '2', text: '学年章が違う' },
      { optionId: '3', text: 'ソックスの色が違う' },
      { optionId: '4', text: 'リボンの色が違う' },
    ],
  },
  {
    quizId: '134',
    question:
      '神原駿河は『駿河』の字を忍野メメに説明するとき、何を例に説明した？',
    options: [
      { optionId: '0', text: '駿河問い' },
      { optionId: '1', text: '駿河湾' },
      { optionId: '2', text: '駿河通り' },
      { optionId: '3', text: '駿河国' },
      { optionId: '4', text: '駿河区' },
    ],
  },
  {
    quizId: '135',
    question:
      '神原駿河が母親から左手の木乃伊がはいった桐の箱を託されたのはいつのこと？',
    options: [
      { optionId: '0', text: '小学三年生' },
      { optionId: '1', text: '小学一年生' },
      { optionId: '2', text: '小学二年生' },
      { optionId: '3', text: '小学四年生' },
      { optionId: '4', text: '小学五年生' },
    ],
  },
  {
    quizId: '136',
    question: '神原駿河の両親は何が原因で亡くなった？',
    options: [
      { optionId: '0', text: '交通事故' },
      { optionId: '1', text: '飛び降り自殺' },
      { optionId: '2', text: '首吊り自殺' },
      { optionId: '3', text: '焼身自殺' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '137',
    question: '神原駿河が左手の木乃伊に初めて願ったのはいつのこと？',
    options: [
      { optionId: '0', text: '小学四年生' },
      { optionId: '1', text: '小学一年生' },
      { optionId: '2', text: '小学二年生' },
      { optionId: '3', text: '小学三年生' },
      { optionId: '4', text: '小学五年生' },
    ],
  },
  {
    quizId: '138',
    question: '神原駿河が左手の木乃伊にした初めて願いは？',
    options: [
      { optionId: '0', text: '『足が速くなりたいです』' },
      { optionId: '1', text: '『徒競走で一等が取りたいです』' },
      { optionId: '2', text: '『いじめられなくなりますように』' },
      { optionId: '3', text: '『皆と仲良くなりたいです』' },
      { optionId: '4', text: '『お父さんとお母さんを生き返らせてください』' },
    ],
  },
  {
    quizId: '139',
    question:
      'するがモンキーより問題です。\n神原駿河の左手と一体化していた怪異は？',
    options: [
      { optionId: '0', text: 'レイニー・デヴィル' },
      { optionId: '1', text: '猿の手' },
      { optionId: '2', text: 'シャイニー・デヴィル' },
      { optionId: '3', text: 'レイニー・デーモン' },
      { optionId: '4', text: 'シャイニー・デーモン' },
    ],
  },
  {
    quizId: '140',
    question: 'ファウストの作者は？',
    options: [
      { optionId: '0', text: 'ヨハン・ウォルフガング・フォン・ゲーテ' },
      { optionId: '1', text: 'ポール・アンダースン' },
      { optionId: '2', text: 'クライヴ・バーカー' },
      { optionId: '3', text: 'メフメット・ムラート・ソマー' },
      { optionId: '4', text: 'ウイリアム・ウイマーク・ジェイソブズ' },
    ],
  },
  {
    quizId: '141',
    question: '神原駿河の母親の結婚前のフルネームは？',
    options: [
      { optionId: '0', text: '臥煙遠江' },
      { optionId: '1', text: '臥煙伊豆湖' },
      { optionId: '2', text: '臥煙長江' },
      { optionId: '3', text: '臥煙長良' },
      { optionId: '4', text: '臥煙黄河' },
    ],
  },
  {
    quizId: '142',
    question:
      'するがモンキーにおいて、阿良々木暦は忍野忍に、デフォルトの何倍くらいの血液を与えた？',
    options: [
      { optionId: '0', text: '五倍' },
      { optionId: '1', text: '一倍' },
      { optionId: '2', text: '二倍' },
      { optionId: '3', text: '三倍' },
      { optionId: '4', text: '十倍' },
    ],
  },
  {
    quizId: '143',
    question:
      '駿河モンキーより問題です。\n忍野忍に血液を与えた後、阿良々木暦は、今度何をお土産に持ってこようと考えていた？',
    options: [
      { optionId: '0', text: 'D-ポップ' },
      { optionId: '1', text: 'フレンチクルーラー' },
      { optionId: '2', text: 'ゴールデンチョコレート' },
      { optionId: '3', text: 'ポン・デ・リング' },
      { optionId: '4', text: 'オールドファッション' },
    ],
  },
  {
    quizId: '144',
    question:
      'するがモンキーより問題です。\n阿良々木暦がレイニー・デヴィルと戦ったのはどこ？',
    options: [
      { optionId: '0', text: '二階の一番奥の教室' },
      { optionId: '1', text: '二階の階段から一番目の教室' },
      { optionId: '2', text: '三階の階段から一番目の教室' },
      { optionId: '3', text: '三階の一番奥の教室' },
      { optionId: '4', text: '四階の階段から一番目の教室' },
    ],
  },
  {
    quizId: '145',
    question: '『デヴィル・メイド・デヴィル・アンド・デヴィル』日本語訳は？',
    options: [
      { optionId: '0', text: '悪魔と遊べば悪魔となる' },
      { optionId: '1', text: '悪魔は悪魔により生まれる' },
      { optionId: '2', text: '悪魔を作るのは悪魔のみ' },
      { optionId: '3', text: '悪魔は増え続ける' },
      { optionId: '4', text: '悪魔を作らば悪魔となる' },
    ],
  },
  {
    quizId: '146',
    question:
      'レイニー・デヴィルと戦った翌日、阿良々木家に迎えに来た神原駿河。彼女は何故阿良々木家を知っていた？',
    options: [
      { optionId: '0', text: 'ストーキングしていたから' },
      { optionId: '1', text: '戦場ヶ原ひたぎに聞いたから' },
      { optionId: '2', text: '走り回って探したから' },
      { optionId: '3', text: '阿良々木暦が偉大だから' },
      { optionId: '4', text: '地図で調べたから' },
    ],
  },
  {
    quizId: '147',
    question:
      'あとがきによると、化物語は三段論法から生まれた話らしいですが、そもそもは『ツンデレ』と何の響きが似ていることから始まった？',
    options: [
      { optionId: '0', text: 'ゲレンデ' },
      { optionId: '1', text: 'ツンドラ' },
      { optionId: '2', text: 'シンデレラ' },
      { optionId: '3', text: 'ツインテ' },
      { optionId: '4', text: 'ナンプレ' },
    ],
  },
  {
    quizId: '148',
    question:
      '小学生時代の阿良々木月火は、学校の友達をどのくらいの頻度で家へ招いていた？',
    options: [
      { optionId: '0', text: '三日に一日' },
      { optionId: '1', text: '毎日' },
      { optionId: '2', text: '二日に一日' },
      { optionId: '3', text: '五日に一日' },
      { optionId: '4', text: '週に一日' },
    ],
  },
  {
    quizId: '149',
    question:
      'なでこスネイクより問題です。\n阿良々木暦が山に登る際に、千石撫子を目撃したのはいつ？',
    options: [
      { optionId: '0', text: '六月十一日' },
      { optionId: '1', text: '六月八日' },
      { optionId: '2', text: '六月九日' },
      { optionId: '3', text: '六月十日' },
      { optionId: '4', text: '六月十二日' },
    ],
  },
  {
    quizId: '150',
    question:
      'なでこスネイクより問題です。\n神原駿河が怪異絡みで忍野メメに力を貸してもらった際の対価として、お札を貼りに山を登る前の、阿良々木暦との待ち合わせ時間は？',
    options: [
      { optionId: '0', text: '午前十一時' },
      { optionId: '1', text: '午前九時' },
      { optionId: '2', text: '午前十時' },
      { optionId: '3', text: '正午' },
      { optionId: '4', text: '不明' },
    ],
  },
  {
    quizId: '151',
    question:
      'なでこスネイクより問題です。\n神原駿河が怪異絡みで忍野メメに力を貸してもらった際の対価として、お札を貼りに山を登る前の、阿良々木暦との待ち合わせ場所は？',
    options: [
      { optionId: '0', text: '直江津高校正門前' },
      { optionId: '1', text: '神原家前' },
      { optionId: '2', text: '阿良々木家前' },
      { optionId: '3', text: '本屋' },
      { optionId: '4', text: '直江津高校駐輪場' },
    ],
  },
  {
    quizId: '152',
    question:
      'なでこスネイク、阿良々木暦のモノローグより問題です。\n『身長差の問題で、丁度僕の肘辺りに神原の胸が来て、神経が集中したその敏感な部位に、○○のような感触が伝わってくる』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'マッシュポテト' },
      { optionId: '1', text: 'マシュマロ' },
      { optionId: '2', text: '大福' },
      { optionId: '3', text: '米粉パン' },
      { optionId: '4', text: 'オムレツ' },
    ],
  },
  {
    quizId: '153',
    question:
      'なでこスネイクより問題です。\n阿良々木暦から電話を受け、デートと勘違いした神原駿河は、生まれて初めての、異性とのデートにどのくらい気合いを入れてきた？',
    options: [
      {
        optionId: '0',
        text: '主義として決して持たないと堅く誓っていた携帯電話を購入するほど',
      },
      { optionId: '1', text: '一晩寝ずにお弁当を作るほど' },
      { optionId: '2', text: '入念に体を洗い、歯磨きには三十分かけるほど' },
      { optionId: '3', text: '結局失敗してしまったが、化粧をしてしまうほど' },
      { optionId: '4', text: '新しく洋服を購入するほど' },
    ],
  },
  {
    quizId: '154',
    question:
      '必死になって食べないとガンガン痩せていくタイプになるには、まず何をすればいい？',
    options: [
      { optionId: '0', text: '毎朝十キロダッシュを2セット' },
      { optionId: '1', text: '登下校は常に全力疾走' },
      { optionId: '2', text: '毎朝十キロのジョギング' },
      { optionId: '3', text: '移動は常にダッシュ' },
      { optionId: '4', text: 'バスケットボール部に入部' },
    ],
  },
  {
    quizId: '155',
    question:
      'なでこスネイクより問題です。\n神原駿河が阿良々木暦に\n「阿良々木先輩っての、やめないか？」\nと言われ、まず提案した呼び名は？',
    options: [
      { optionId: '0', text: '気仙沼先輩' },
      { optionId: '1', text: '阿良々木様' },
      { optionId: '2', text: '暦先輩' },
      { optionId: '3', text: '阿良々木師匠' },
      { optionId: '4', text: 'ミスター阿良々木' },
    ],
  },
  {
    quizId: '156',
    question:
      'なでこスネイクより問題です。\n神原駿河が阿良々木暦に、最初につけたキャッチコピーは？',
    options: [
      { optionId: '0', text: '『駆け抜ける迅雷の騎士』' },
      { optionId: '1', text: '『今世紀最後の英雄』' },
      { optionId: '2', text: '『闇の血族』' },
      { optionId: '3', text: '『何かを司る先駆者』' },
      { optionId: '4', text: '『疾風怒濤の高校生』' },
    ],
  },
  {
    quizId: '157',
    question: '阿良々木暦の名付け親は誰？',
    options: [
      { optionId: '0', text: '祖父' },
      { optionId: '1', text: '祖母' },
      { optionId: '2', text: '父' },
      { optionId: '3', text: '母' },
      { optionId: '4', text: '叔父' },
    ],
  },
  {
    quizId: '158',
    question:
      'なでこスネイクより問題です。\n神原駿河が阿良々木暦に、最初に付けたニックネームは？',
    options: [
      { optionId: '0', text: 'ラギ' },
      { optionId: '1', text: 'ラギ子' },
      { optionId: '2', text: 'ララ' },
      { optionId: '3', text: 'こよみん' },
      { optionId: '4', text: 'アーミ' },
    ],
  },
  {
    quizId: '159',
    question:
      'なでこスネイクより問題です。\n神原駿河に対する、阿良々木暦イメージ悪化計画、その一は？',
    options: [
      { optionId: '0', text: '金にだらしのない男' },
      { optionId: '1', text: '時間にだらしのない男' },
      { optionId: '2', text: 'やたらエロい男' },
      { optionId: '3', text: '誇大妄想的な夢を語る男' },
      { optionId: '4', text: '不潔な男' },
    ],
  },
  {
    quizId: '160',
    question:
      'なでこスネイク、阿良々木暦悪化計画の阿良々木暦と神原駿河の会話より問題です。\n「僕はミュージシャンになる」\n「そうか。ならば私は○○になろう」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '楽器' },
      { optionId: '1', text: 'ファン一号' },
      { optionId: '2', text: 'ドラマー' },
      { optionId: '3', text: 'ボーカル' },
      { optionId: '4', text: 'バンド' },
    ],
  },
  {
    quizId: '161',
    question: '神原駿河は、『愚問』を何だと思っていた？',
    options: [
      { optionId: '0', text: '『グッドモーニング』の略' },
      { optionId: '1', text: '私に使われるべき言葉' },
      { optionId: '2', text: '塾の名前' },
      { optionId: '3', text: 'ソロモン七十二柱のなにか' },
      { optionId: '4', text: '虚空蔵菩薩' },
    ],
  },
  {
    quizId: '162',
    question:
      'なでこスネイクより問題です。\n「私はこの生涯を、阿良々木先輩に捧げると誓ったのだ。戦場ヶ原先輩との仲を取り持ってくれたからというのではない。阿良々木先輩がそうするに値する人だと思うから、そう誓ったのだ」\n神原駿河はそのことを何に誓った？',
    options: [
      { optionId: '0', text: '街灯' },
      { optionId: '1', text: '太陽' },
      { optionId: '2', text: '新月' },
      { optionId: '3', text: '戦場ヶ原ひたぎ' },
      { optionId: '4', text: '両親' },
    ],
  },
  {
    quizId: '163',
    question:
      'なでこスネイク、神原駿河の台詞より問題です。\n「まあ、生涯を阿良々木先輩に捧げるなどとだいそれたこと、私には○○かもしれんがな」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '約不足' },
      { optionId: '1', text: '周良不足' },
      { optionId: '2', text: '役不足' },
      { optionId: '3', text: '力不足' },
      { optionId: '4', text: '力不手' },
    ],
  },
  {
    quizId: '164',
    question: '十二星座で考えた場合、戦場ヶ原ひたぎの星座は何？',
    options: [
      { optionId: '0', text: 'かに座' },
      { optionId: '1', text: 'ふたご座' },
      { optionId: '2', text: 'しし座' },
      { optionId: '3', text: 'おとめ座' },
      { optionId: '4', text: 'へびつかい座' },
    ],
  },
  {
    quizId: '165',
    question: '十三星座で考えた場合、戦場ヶ原ひたぎの星座は何？',
    options: [
      { optionId: '0', text: 'ふたご座' },
      { optionId: '1', text: 'かに座' },
      { optionId: '2', text: 'へびつかい座' },
      { optionId: '3', text: 'しし座' },
      { optionId: '4', text: 'おとめ座' },
    ],
  },
  {
    quizId: '166',
    question: 'へびつかい座は、何という医聖の姿を表したもの？',
    options: [
      { optionId: '0', text: 'アスクレピウス' },
      { optionId: '1', text: 'デーメーテール' },
      { optionId: '2', text: 'ヘーラー' },
      { optionId: '3', text: 'ポリュデウケス' },
      { optionId: '4', text: 'ヘラクレス' },
    ],
  },
  {
    quizId: '167',
    question:
      'なでこスネイク、阿良々木暦と神原駿河の会話より問題です。\n「○○」\n「なんだ、らぎ子ちゃん」\n「その左腕――どんな調子だ？」\n「うん？　どういう意味だ？」\n「いや、何か変わったことはないかと思って」\n「特にない」\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'ばるかん後輩' },
      { optionId: '1', text: '神原後輩' },
      { optionId: '2', text: 'すがる後輩' },
      { optionId: '3', text: '駿河後輩' },
      { optionId: '4', text: 'バルス後輩' },
    ],
  },
  {
    quizId: '168',
    question:
      'なでこスネイクより問題です。\n目を見れば相手の考えがわかる神原駿河が読み取った、阿良々木暦の考えは？',
    options: [
      { optionId: '0', text: 'この女、頼んだらブラジャー外してくれねえかなあ' },
      { optionId: '1', text: 'この女、頼んだらおっぱい揉ましてくれねえかなあ' },
      { optionId: '2', text: 'この女、頼んだら何でもしてくれそうだよなあ' },
      { optionId: '3', text: 'この女、僕のこと好きなのか？' },
      { optionId: '4', text: 'エロい後輩を持って、僕は何て幸せなんだろう' },
    ],
  },
  {
    quizId: '169',
    question:
      '神原駿河の左腕は、何もしなければいつまでには治ると、忍野メメに言われている？',
    options: [
      { optionId: '0', text: '二十歳' },
      { optionId: '1', text: '十八歳' },
      { optionId: '2', text: '二十二歳' },
      { optionId: '3', text: '二十四歳' },
      { optionId: '4', text: '二十五歳' },
    ],
  },
  {
    quizId: '170',
    question: '阿良々木暦が、どんな番外編でも語り部に選ばれないと思っのは誰？',
    options: [
      { optionId: '0', text: '神原駿河' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '八九寺真宵' },
      { optionId: '3', text: '千石撫子' },
      { optionId: '4', text: '羽川翼' },
    ],
  },
  {
    quizId: '171',
    question: '実力テストの結果、戦場ヶ原ひたぎの順位は？',
    options: [
      { optionId: '0', text: '学年七位' },
      { optionId: '1', text: '学年三位' },
      { optionId: '2', text: '学年五位' },
      { optionId: '3', text: '学年六位' },
      { optionId: '4', text: '学年八位' },
    ],
  },
  {
    quizId: '172',
    question: '神原駿河のお祖母ちゃんが作ったお弁当、どこで食べた？',
    options: [
      { optionId: '0', text: '公園' },
      { optionId: '1', text: '神社の境内' },
      { optionId: '2', text: '山の中腹' },
      { optionId: '3', text: '阿良々木家' },
      { optionId: '4', text: '神原家' },
    ],
  },
  {
    quizId: '173',
    question:
      '妖怪大戦争を未然に防ぐため、阿良々木暦と神原駿河が、お札を貼りに行った神社は？',
    options: [
      { optionId: '0', text: '北白蛇神社' },
      { optionId: '1', text: '直江津神社' },
      { optionId: '2', text: '城白蛇神社' },
      { optionId: '3', text: '中白蛇神社' },
      { optionId: '4', text: '神白蛇神社' },
    ],
  },
  {
    quizId: '174',
    question:
      'なでこスネイク、阿良々木暦と羽川翼の会話より問題です。\n「阿良々木くん、彼女の後輩と仲良し過ぎるのって、問題ない？　そりゃ、戦場ヶ原さんと神原さんの仲を取り持ったのは阿良々木くんなんだから、ある程度仲良しなのは、いいと思うんだけど。腕を組むのはまずいでしょ」\n「しょうがねえだろ。○○なんだよ」\n「そんな言葉が言い訳になると思う？」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '人懐っこい奴' },
      { optionId: '1', text: '可愛い後輩' },
      { optionId: '2', text: '純粋な奴' },
      { optionId: '3', text: 'そういう性格' },
      { optionId: '4', text: '皆仲がいい奴ら' },
    ],
  },
  {
    quizId: '175',
    question:
      '羽川翼は卒業後に旅に出ようと考えていますが、どのくらいの期間で計画している？',
    options: [
      { optionId: '0', text: '二年くらい' },
      { optionId: '1', text: '半年くらい' },
      { optionId: '2', text: '一年くらい' },
      { optionId: '3', text: '五年くらい' },
      { optionId: '4', text: '十年くらい' },
    ],
  },
  {
    quizId: '176',
    question:
      'なでこスネイク、阿良々木暦と羽川翼の会話より問題です。\n「ちょっと前から、たまにあるんだ。急に頭が痛むの」\n「おいおい……大丈夫じゃねえだろ、それ」\n「うーん。でも、すぐ治っちゃうし。原因はわからないんだけど……最近、○○かな」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '文化祭の準備にかまけて、勉強をサボってるから' },
      { optionId: '1', text: '文化祭の準備にかまけて、本が読めてないから' },
      { optionId: '2', text: '文化祭の準備にかまけて、ちょっと寝不足' },
      { optionId: '3', text: '勉強に重点を置きすぎて、運動不足' },
      { optionId: '4', text: '運動に重点を置きすぎて、勉強不足' },
    ],
  },
  {
    quizId: '177',
    question: '原作において、羽川翼に勧められた合計一万円の参考書、冊数は？',
    options: [
      { optionId: '0', text: '六冊' },
      { optionId: '1', text: '四冊' },
      { optionId: '2', text: '五冊' },
      { optionId: '3', text: '七冊' },
      { optionId: '4', text: '八冊' },
    ],
  },
  {
    quizId: '178',
    question: '千石撫子が立ち読みしていた、呪術・オカルト関係の本、値段は？',
    options: [
      { optionId: '0', text: '一万二千円' },
      { optionId: '1', text: '二千五百円' },
      { optionId: '2', text: '五千円' },
      { optionId: '3', text: '八千円' },
      { optionId: '4', text: '二万円' },
    ],
  },
  {
    quizId: '179',
    question:
      '阿良々木暦が神原駿河の携帯電話に初めて電話したときの、神原駿河の受け答えは？',
    options: [
      { optionId: '0', text: '神原駿河。得意技は二段ジャンプだ' },
      { optionId: '1', text: '神原駿河。得意技はBダッシュだ' },
      { optionId: '2', text: '神原駿河。職業は阿良々木先輩のエロ奴隷だ' },
      { optionId: '3', text: '神原駿河。主な武器は加速装置だ' },
      { optionId: '4', text: '神原駿河。人生の指針は阿良々木先輩だ' },
    ],
  },
  {
    quizId: '180',
    question:
      'なでこスネイク、阿良々木暦と神原駿河の会話より問題です。\n「今日は新刊の発売日だったものでな、試験中だったから買えなかったものも含め、二十冊ほど購入したのだ」\n「はあ……いわゆる大人買いって奴な」\n「ちっちっち。この場合は○○と言って欲しい」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '乙女買い' },
      { optionId: '1', text: '衝動買い' },
      { optionId: '2', text: '青年買い' },
      { optionId: '3', text: 'ナイス買い' },
      { optionId: '4', text: '少女買い' },
    ],
  },
  {
    quizId: '181',
    question:
      'なでこスネイク、阿良々木暦と神原駿河の会話より問題です。\n「やれやれ……。ぼくはたまにはお前と知的な会話を交わしたいよ……お前、確か、結構、頭いいはずだろ？」\n「うん。私は○○だぞ」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '成積はいい方' },
      { optionId: '1', text: '学年二十五位' },
      { optionId: '2', text: '優秀' },
      { optionId: '3', text: '頭もいい方' },
      { optionId: '4', text: '結構馬鹿' },
    ],
  },
  {
    quizId: '182',
    question:
      'なでこスネイク、阿良々木暦と神原駿河の会話より問題です。\n「しかし、僕に言わせりゃ、お前の足の速さは人類の枠に収まらないと思うんだよな」\n「ふむ。人類の枠に収まらないとなると……なんだろう、私は○○なのだろうか？」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '両生類' },
      { optionId: '1', text: '火星人' },
      { optionId: '2', text: 'バータ' },
      { optionId: '3', text: '怪異' },
      { optionId: '4', text: 'サイボーグ' },
    ],
  },
  {
    quizId: '183',
    question:
      'なでこスネイク、阿良々木暦と神原駿河の会話より問題です。\n「昨日、この階段を昇る途中ですれ違った女の子、憶えてるか？」\n「うん。ちっちゃくて可愛らしい女の子だった」\n「その覚え方はどうかと思うが……」\n「阿良々木先輩風に言うなら、腰の形が○○な女の子だった」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'プリティー' },
      { optionId: '1', text: 'セクシー' },
      { optionId: '2', text: '安産型' },
      { optionId: '3', text: 'ナイス' },
      { optionId: '4', text: '魅力的' },
    ],
  },
  {
    quizId: '184',
    question:
      'なでこスネイクより問題です。\n忍野メメからの仕事で山へ昇っていた阿良々木暦と神原駿河がすれ違った女の子が阿良々木月火の旧友だと聞き、神原駿河はどのくらい驚いた？',
    options: [
      { optionId: '0', text: '今朝起きたら目覚まし時計が止まっていたとき以来' },
      { optionId: '1', text: '阿良々木先輩から電話が掛かってきたとき依頼' },
      { optionId: '2', text: '先週買ったBL本が表紙に反して過激だったとき以来' },
      { optionId: '3', text: 'ビックバン以来' },
      { optionId: '4', text: '第三次世界大戦以来' },
    ],
  },
  {
    quizId: '185',
    question:
      '神原駿河が迎えたいと言っている最終回は、\n『戦場ヶ原ひたぎと阿良々木暦との三人で集合して、記念写真を撮るような最終回』\nという感じのもの、あるいは？',
    options: [
      {
        optionId: '0',
        text: '夕暮れの空を見上げて、そこに映るお二人の姿を眺めるような最終回',
      },
      {
        optionId: '1',
        text: '戦場ヶ原ひたぎに向けて阿良々木暦とブーケを投げるような最終回',
      },
      {
        optionId: '2',
        text: '可愛い女の子たちに囲まれて、今までの夢から覚めるような最終回',
      },
      {
        optionId: '3',
        text: 'バスケットボールで全国優勝し、それを阿良々木暦に報告するような最終回',
      },
      {
        optionId: '4',
        text: '戦場ヶ原ひたぎと阿良々木暦の二人からプロポーズを受けて締める最終回',
      },
    ],
  },
  {
    quizId: '186',
    question: '千石撫子が蛇を切り刻むときに、使用したものは？',
    options: [
      { optionId: '0', text: '彫刻刀' },
      { optionId: '1', text: '果物ナイフ' },
      { optionId: '2', text: '包丁' },
      { optionId: '3', text: '鋏' },
      { optionId: '4', text: 'カッターナイフ' },
    ],
  },
  {
    quizId: '187',
    question: 'なでこスネイクより問題です。\n千石撫子に憑いていた怪異は？',
    options: [
      { optionId: '0', text: '蛇切縄' },
      { optionId: '1', text: '蛇斬縄' },
      { optionId: '2', text: '蛇霧縄' },
      { optionId: '3', text: '蛇桐縄' },
      { optionId: '4', text: '蛇錐縄' },
    ],
  },
  {
    quizId: '188',
    question: '家族以外の女で、阿良々木暦の部屋に初めて入ったのは？',
    options: [
      { optionId: '0', text: '神原駿河と千石撫子' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '羽川翼' },
      { optionId: '3', text: '忍野忍' },
      { optionId: '4', text: '戦場ヶ原ひたぎと神原駿河' },
    ],
  },
  {
    quizId: '189',
    question:
      'なでこスネイクより問題です。\n神原駿河が阿良々木暦の部屋で探そうとしたものは？',
    options: [
      { optionId: '0', text: 'エロ本' },
      { optionId: '1', text: 'アルバム' },
      { optionId: '2', text: '文集' },
      { optionId: '3', text: '戦場ヶ原ひたぎの写真' },
      { optionId: '4', text: '浮気の証拠' },
    ],
  },
  {
    quizId: '190',
    question:
      '忍→○○\n忍野→軽薄皮肉\n羽川→説教指導\n戦場ヶ原→暴言毒舌\n八九寺→慇懃無礼\n神原→甘言褒舌',
    options: [
      { optionId: '0', text: '高慢横柄' },
      { optionId: '1', text: '傲慢不遜' },
      { optionId: '2', text: '傍若無人' },
      { optionId: '3', text: '牢固無言' },
      { optionId: '4', text: '剛毅木訥' },
    ],
  },
  {
    quizId: '191',
    question:
      '忍→高慢横柄\n忍野→軽薄皮肉\n羽川→説教指導\n戦場ヶ原→暴言毒舌\n八九寺→慇懃無礼\n神原→○○',
    options: [
      { optionId: '0', text: '甘言褒舌' },
      { optionId: '1', text: '美辞麗句' },
      { optionId: '2', text: '疾風怒濤' },
      { optionId: '3', text: '運動万能' },
      { optionId: '4', text: '巧言賛辞' },
    ],
  },
  {
    quizId: '192',
    question:
      'なでこスネイク、神原駿河の台詞より問題です。\n「そう捨て鉢になるな、阿良々木先輩。よく言うだろう。冬が来たら○○が来て、夜が来ると△△が来る」\n○○、△△に入る言葉は？',
    options: [
      { optionId: '0', text: '氷河期、暗黒の世紀' },
      { optionId: '1', text: '春、朝' },
      { optionId: '2', text: '秋、昼' },
      { optionId: '3', text: '猫、ふくろう' },
      { optionId: '4', text: '猿、蛇' },
    ],
  },
  {
    quizId: '193',
    question: '神原駿河がレディとして当然の嗜みとして持っていたものは？',
    options: [
      { optionId: '0', text: 'ブルマー' },
      { optionId: '1', text: 'スクール水着' },
      { optionId: '2', text: 'スカートタオル' },
      { optionId: '3', text: '暗視ゴーグル' },
      { optionId: '4', text: 'ソーイングセット' },
    ],
  },
  {
    quizId: '194',
    question: '先見の明がある神原駿河が保護したブルマーの数は？',
    options: [
      { optionId: '0', text: '百五十着' },
      { optionId: '1', text: '五十着' },
      { optionId: '2', text: '二百五十着' },
      { optionId: '3', text: '三百五十着' },
      { optionId: '4', text: '四百五十着' },
    ],
  },
  {
    quizId: '195',
    question:
      'なでこスネイク、阿良々木暦のモノローグより問題です。\n『はっきり言って、恩人でもなければ、あんまり親交を深めたいタイプの人間では、忍野は、ない。ありえない。\n性格は悪い。間違っても、善意の人間ではない。○○の権化のような男である。春休みからの長い付き合いになるが、いまだにそのパーソナリティには、理解不能なエリアが多い』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '気まぐれ' },
      { optionId: '1', text: 'いい加減' },
      { optionId: '2', text: '不誠実' },
      { optionId: '3', text: '悪' },
      { optionId: '4', text: '資本主義' },
    ],
  },
  {
    quizId: '196',
    question:
      '忍野メメは、戦場ヶ原ひたぎをツンデレちゃん、羽川翼を委員長ちゃん、八九寺真宵を迷子ちゃんと呼びますが、神原駿河のことは何と呼ぶ？',
    options: [
      { optionId: '0', text: '百合っ子ちゃん' },
      { optionId: '1', text: 'えろっ子ちゃん' },
      { optionId: '2', text: 'スポーツ少女ちゃん' },
      { optionId: '3', text: '後輩ちゃん' },
      { optionId: '4', text: 'やおいちゃん' },
    ],
  },
  {
    quizId: '197',
    question:
      'なでこスネイクより問題です。\n千石撫子が立ち読みしていた、呪術・オカルト関係の本、タイトルは？',
    options: [
      { optionId: '0', text: '蛇の呪い全集' },
      { optionId: '1', text: '蛇神信仰' },
      { optionId: '2', text: '蛇の呪法全書' },
      { optionId: '3', text: '神仏呪法実践読本' },
      { optionId: '4', text: '蛇神解呪の書' },
    ],
  },
  {
    quizId: '198',
    question:
      'なでこスネイク、阿良々木暦と忍野メメの会話より問題です。\n「まあ、すんでのところで阿良々木くんと再会したっていうのは、不幸中の幸いなのかもしれないな――阿良々木くんは当然、その子をなんとかしてあげるつもりなんだろう？」\n「……悪いかよ」\n「別に悪くはないさ。○○だもんね。でも、僕あたりにゃちょっとわからないかな。可哀想だって思うのはわかるけれど、どうしてそこまで親身になってあげるんだい？」\n○○に入ることわざは？',
    options: [
      { optionId: '0', text: '義を見てせざるは勇なきなり' },
      { optionId: '1', text: '正直の頭に神宿る' },
      { optionId: '2', text: '陰徳あれば必ず陽報あり' },
      { optionId: '3', text: '君子危うきに近寄らず' },
      { optionId: '4', text: '触らぬ神に祟りなし' },
    ],
  },
  {
    quizId: '199',
    question:
      'なでこスネイクより問題です。\n書物において蛇切縄が初めて登場する、江戸時代中期に纏められた本は？',
    options: [
      { optionId: '0', text: '蛇呪集' },
      { optionId: '1', text: '古今百物語評判' },
      { optionId: '2', text: '浮世草子' },
      { optionId: '3', text: '世俗妖怪絵巻' },
      { optionId: '4', text: '長崎見聞録' },
    ],
  },
  {
    quizId: '200',
    question:
      'なでこスネイク、阿良々木暦と忍野メメの会話より問題です。\n「なんだよ、えらくあっさり認めるな」\n「たまには僕も素直にはなるさ。○○だからね」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '暇' },
      { optionId: '1', text: 'ひねくれ者' },
      { optionId: '2', text: '専門家' },
      { optionId: '3', text: '非常事態' },
      { optionId: '4', text: 'たまには' },
    ],
  },
  {
    quizId: '201',
    question:
      'なでこスネイク、忍野メメの台詞より問題です。\n「○○――だよ。まあ、別にその子も、本気でお嬢ちゃんを殺そうと思ったわけじゃないはずだし、呪い自体、全然信じちゃいなかったんだろう。『あんたに呪いを掛けてやったわ』程度の、嫌がらせのつもりだったんだろうなあ」\n○○に入ることわざは？',
    options: [
      { optionId: '0', text: '人を呪わば穴二つ' },
      { optionId: '1', text: '苦しい時の神頼み' },
      { optionId: '2', text: '藪をつついて蛇を出す' },
      { optionId: '3', text: '口は禍の門' },
      { optionId: '4', text: '禍福は糾える縄の如し' },
    ],
  },
  {
    quizId: '202',
    question:
      'なでこスネイクより問題です。\n忍野メメにもらった、蛇切縄を祓うためのお守り。表には何と書いてある？',
    options: [
      { optionId: '0', text: '何も書かれていない' },
      { optionId: '1', text: '交通安全' },
      { optionId: '2', text: 'お守り' },
      { optionId: '3', text: '厄除け' },
      { optionId: '4', text: '安全祈願' },
    ],
  },
  {
    quizId: '203',
    question:
      'なでこスネイクより問題です。\n千石撫子は怪異を払うとき、親に対してどのようなアリバイ作りをした？',
    options: [
      { optionId: '0', text: 'お泊り会' },
      { optionId: '1', text: '天体観測' },
      { optionId: '2', text: 'ゲームの発売に備えて店頭で徹夜' },
      { optionId: '3', text: '災害に備えて学校で宿泊訓練' },
      { optionId: '4', text: 'バーベキュー' },
    ],
  },
  {
    quizId: '204',
    question:
      'なでこスネイクより問題です。\n千石撫子に憑いている蛇を払うための必要機材はどこで購入した？',
    options: [
      { optionId: '0', text: '雑貨屋' },
      { optionId: '1', text: 'コンビニ' },
      { optionId: '2', text: 'スーパー' },
      { optionId: '3', text: 'ホームセンター' },
      { optionId: '4', text: 'デパート' },
    ],
  },
  {
    quizId: '205',
    question: '千石撫子は阿良々木月火のことを、何と呼ぶ？',
    options: [
      { optionId: '0', text: 'ららちゃん' },
      { optionId: '1', text: '阿良々木さん' },
      { optionId: '2', text: '月火ちゃん' },
      { optionId: '3', text: 'つーちゃん' },
      { optionId: '4', text: 'らぎちゃん' },
    ],
  },
  {
    quizId: '206',
    question:
      '阿良々木暦に\n「何か面白いことを言ってみろ」\nと言われた、神原駿河が返した台詞は？',
    options: [
      {
        optionId: '0',
        text: '仕方ないではないか！　やらなければお金をくれないと脅迫されたのだ！',
      },
      {
        optionId: '1',
        text: '私は車の中で本を読んで、酔って気分が悪くなるのが好きだ',
      },
      { optionId: '2', text: '好きな女の子が処女かと思ったら猩々だった' },
      { optionId: '3', text: '私の知り合いには十三星座で考えている人がいる' },
      { optionId: '4', text: '私はツンデレなんかじゃ、ないんだからね' },
    ],
  },
  {
    quizId: '207',
    question: '阿良々木暦は千石撫子を何上戸だと考えている？',
    options: [
      { optionId: '0', text: '笑い上戸' },
      { optionId: '1', text: '泣き上戸' },
      { optionId: '2', text: '暴れ上戸' },
      { optionId: '3', text: '照れ上戸' },
      { optionId: '4', text: '怒り上戸' },
    ],
  },
  {
    quizId: '208',
    question: '蛇切縄を祓うための正しい手順を行うにあたり、重要なことは？',
    options: [
      { optionId: '0', text: '場所' },
      { optionId: '1', text: '道具' },
      { optionId: '2', text: '時間' },
      { optionId: '3', text: '時期' },
      { optionId: '4', text: '人物' },
    ],
  },
  {
    quizId: '209',
    question:
      'なでこスネイク、神原駿河の台詞より問題です。\n「私もそうだったが、あの年頃の女の子が、みんな、○○を待ち焦がれているとは限らないさ」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '白衣の王子様' },
      { optionId: '1', text: 'ヒーロー' },
      { optionId: '2', text: '白婆の王子様' },
      { optionId: '3', text: '白歯の王子様' },
      { optionId: '4', text: '白馬の王子様' },
    ],
  },
  {
    quizId: '210',
    question:
      '千石撫子に憑いていた蛇が暴走した際、千石の身体はどうなっていた？',
    options: [
      { optionId: '0', text: '火傷するんじゃないかと思うほど熱を持っていた' },
      { optionId: '1', text: '死んでいるんじゃないかと思うほど冷えていた' },
      { optionId: '2', text: '石かと思うほど固くなっていた' },
      { optionId: '3', text: 'マシュマロのように柔らかくなっていた' },
      { optionId: '4', text: '特に変化はない' },
    ],
  },
  {
    quizId: '211',
    question: '阿良々木暦が蛇切縄に攻撃された部位は？',
    options: [
      { optionId: '0', text: '右腕、左足首' },
      { optionId: '1', text: '左手首、左足首' },
      { optionId: '2', text: '右腕、右足首' },
      { optionId: '3', text: '左腕、左足首' },
      { optionId: '4', text: '左腕、右足首' },
    ],
  },
  {
    quizId: '212',
    question:
      '千石撫子から蛇切縄を祓った夜、阿良々木暦たちはどこで夜を明かした？',
    options: [
      { optionId: '0', text: '学習塾跡' },
      { optionId: '1', text: '阿良々木家' },
      { optionId: '2', text: '神原家' },
      { optionId: '3', text: '公園' },
      { optionId: '4', text: '山中' },
    ],
  },
  {
    quizId: '213',
    question: '阿良々木暦は小学生のとき、千石撫子をどのように呼んでいた？',
    options: [
      { optionId: '0', text: 'せんちゃん' },
      { optionId: '1', text: 'なでしこちゃん' },
      { optionId: '2', text: 'なでこちゃん' },
      { optionId: '3', text: 'なでちゃん' },
      { optionId: '4', text: '千石ちゃん' },
    ],
  },
  {
    quizId: '214',
    question: 'GWに羽川翼が猫に魅せられた期間は？',
    options: [
      { optionId: '0', text: '九日間' },
      { optionId: '1', text: '五日間' },
      { optionId: '2', text: '六日間' },
      { optionId: '3', text: '七日間' },
      { optionId: '4', text: '八日間' },
    ],
  },
  {
    quizId: '215',
    question: '阿良々木暦と戦場ヶ原ひたぎが初めてデートしたのはいつ？',
    options: [
      { optionId: '0', text: '六月十三日' },
      { optionId: '1', text: '六月十日' },
      { optionId: '2', text: '六月二十日' },
      { optionId: '3', text: '六月二十三日' },
      { optionId: '4', text: '七月七日' },
    ],
  },
  {
    quizId: '216',
    question: '蛇切縄を祓った翌日、千石撫子は学校を休みましたが、それは何故？',
    options: [
      { optionId: '0', text: '眠いから' },
      { optionId: '1', text: '身体が痛いから' },
      { optionId: '2', text: '風邪をひいたから' },
      { optionId: '3', text: '創立記念日だったから' },
      { optionId: '4', text: '友達に会いたくなかったから' },
    ],
  },
  {
    quizId: '217',
    question:
      '千石撫子から蛇切縄を祓った夜、阿良々木暦たちは何を枕代わりに眠った？',
    options: [
      { optionId: '0', text: 'ペットボトル' },
      { optionId: '1', text: 'ブルマー' },
      { optionId: '2', text: 'スクール水着' },
      { optionId: '3', text: '腕' },
      { optionId: '4', text: 'ビニールシート' },
    ],
  },
  {
    quizId: '218',
    question:
      '蛇切縄を祓った翌日、千石撫子は阿良々木暦を待ってどのくらい直江津高校正門前にいた？',
    options: [
      { optionId: '0', text: '四時間以上' },
      { optionId: '1', text: '三十分くらい' },
      { optionId: '2', text: '一時間くらい' },
      { optionId: '3', text: '二時間くらい' },
      { optionId: '4', text: '三時間くらい' },
    ],
  },
  {
    quizId: '219',
    question:
      '神原駿河が眼にもと止まらないものすごいスピードで走り去っていった様子を、千石撫子は何のようだったと言った？',
    options: [
      { optionId: '0', text: '達急動' },
      { optionId: '1', text: '縮地法' },
      { optionId: '2', text: '遠近法' },
      { optionId: '3', text: '四不象' },
      { optionId: '4', text: 'ワイリー・コヨーテとロード・ランナー' },
    ],
  },
  {
    quizId: '220',
    question:
      '千石撫子が、山で蛇をぶつ切りにしていたときと、直江津高校正門前で阿良々木暦を待っていたときに、共通して身に着けていたものは？',
    options: [
      { optionId: '0', text: 'ウエストポーチ' },
      { optionId: '1', text: '帽子' },
      { optionId: '2', text: '制服' },
      { optionId: '3', text: 'ワンピース' },
      { optionId: '4', text: 'メガネ' },
    ],
  },
  {
    quizId: '221',
    question:
      '忍野メメから貰ったお守りを、千石撫子はドラえもんの秘密道具で例える際、どの道具を挙げた？',
    options: [
      { optionId: '0', text: '天才ヘルメットと技術手袋' },
      { optionId: '1', text: 'タケコプターとどこでもドア' },
      { optionId: '2', text: '交通安全お守りとキャンピングカプセル' },
      { optionId: '3', text: '四次元ポケットとペタリハンド' },
      { optionId: '4', text: 'タケノコプターとどこだかドア' },
    ],
  },
  {
    quizId: '222',
    question:
      'つばさキャット、阿良々木暦のモノローグより問題です。\n『お前が試す側かよ！\n突っ込みには限度はないが○○には限度があるぞ。\n愉快なことするじゃねえか、この内気少女。』\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '我慢' },
      { optionId: '1', text: 'ボケ' },
      { optionId: '2', text: '辛抱' },
      { optionId: '3', text: '堪忍袋' },
      { optionId: '4', text: '給料袋' },
    ],
  },
  {
    quizId: '223',
    question:
      'つばさキャットより問題です。\n阿良々木暦が羽川翼から聞いた、面白い噂は？',
    options: [
      {
        optionId: '0',
        text: '戦場ヶ原は阿良々木と仲良くなってから態度がおかしくなった',
      },
      { optionId: '1', text: '阿良々木が二年の神原と山に入っていったらしい' },
      {
        optionId: '2',
        text: '阿良々木は三年になってから様子がやわらしくなった',
      },
      { optionId: '3', text: '阿良々木が夜中に中学生と歩いていたらしい' },
      {
        optionId: '4',
        text: '阿良々木が小学生と過度なスキンシップをとっている姿が目撃されている',
      },
    ],
  },
  {
    quizId: '224',
    question:
      '「デートをします」\nと戦場ヶ原ひたぎに言われた阿良々木暦は、何を取り落とすほど呆気に取られた？',
    options: [
      { optionId: '0', text: '卵焼き' },
      { optionId: '1', text: 'シャーペン' },
      { optionId: '2', text: '鞄' },
      { optionId: '3', text: '参考書' },
      { optionId: '4', text: 'バスケットボール' },
    ],
  },
  {
    quizId: '225',
    question:
      'つばさキャット、戦場ヶ原ひたぎの台詞より問題です。\n「あの子と阿良々木くんが仲良くなったみたいで、よかったわ」\n「…………」\n「これで神原は、阿良々木くんに対して○○としての価値を持ったわね」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '人質' },
      { optionId: '1', text: '後輩' },
      { optionId: '2', text: '切り札' },
      { optionId: '3', text: '桂馬' },
      { optionId: '4', text: 'リセットボタン' },
    ],
  },
  {
    quizId: '226',
    question:
      '戦場ヶ原ひたぎから阿良々木暦へのデートの誘い、最終的にはどう落ち着いた？',
    options: [
      { optionId: '0', text: '私とデートをしなさい、阿良々木くん' },
      { optionId: '1', text: '私とデートをしていただけませんか、阿良々木くん' },
      { optionId: '2', text: '私とデートをしましょう、阿良々木くん' },
      { optionId: '3', text: '私とデートをしたらどうなのですか？' },
      { optionId: '4', text: '私とデートをしないといけません、阿良々木くん' },
    ],
  },
  {
    quizId: '227',
    question:
      '正門前でブルマーとスクール水着を持っているところを羽川翼に目撃された阿良々木暦は、何を条件に誰にも話さないよう懇願した？',
    options: [
      { optionId: '0', text: '五万円払う' },
      { optionId: '1', text: '勉強を頑張る' },
      { optionId: '2', text: '文化祭の準備を羽川の分までする' },
      { optionId: '3', text: '羽川が疲れたら、いつでも肩を揉みに駆けつける' },
      { optionId: '4', text: '羽川の願いを一つ叶える' },
    ],
  },
  {
    quizId: '228',
    question: '原作において、戦場ヶ原父が運転した乗り物は？',
    options: [
      { optionId: '0', text: 'ジープ' },
      { optionId: '1', text: 'バギー' },
      { optionId: '2', text: 'ミニバン' },
      { optionId: '3', text: 'セダン' },
      { optionId: '4', text: 'SUV' },
    ],
  },
  {
    quizId: '229',
    question:
      'つばさキャット、戦場ヶ原ひたぎの台詞より問題です。\n「阿良々木くんは突っ込みだけはいつだって○○なのね。いいわ。じゃあ親切にも、私から話を振ってあげます。阿良々木くんはそれに応えてくれればいいわ」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '腕白' },
      { optionId: '1', text: '満点' },
      { optionId: '2', text: '完璧' },
      { optionId: '3', text: '積極的' },
      { optionId: '4', text: '凶暴' },
    ],
  },
  {
    quizId: '230',
    question: '人に儚いと書いて何と読む？',
    options: [
      { optionId: '0', text: 'あららぎ' },
      { optionId: '1', text: 'はねかわつばさ' },
      { optionId: '2', text: '恋' },
      { optionId: '3', text: 'ロマンチック' },
      { optionId: '4', text: 'そんな字はない' },
    ],
  },
  {
    quizId: '231',
    question:
      '戦場ヶ原ひたぎは阿良々木暦のどういうところが好きだと言っている？',
    options: [
      {
        optionId: '0',
        text: '優しいところ。可愛いところ。私が困っているときにはいつだって助けに駆けつけてくれる王子様みたいなところ。',
      },
      {
        optionId: '1',
        text: '優しいところ。格好いいところ。私が困っているときにはいつだって助けに駆けつけてくれる王子様みたいなところ。',
      },
      {
        optionId: '2',
        text: '楽しいところ。可愛いところ。私が困っているときにはいつだって助けに駆けつけてくれる王子様みたいなところ。',
      },
      {
        optionId: '3',
        text: '楽しいところ。格好いいところ。私が困っているときにはいつだって助けに駆けつけてくれる王子様みたいなところ。',
      },
      { optionId: '4', text: '全部好き' },
    ],
  },
  {
    quizId: '232',
    question: '戦場ヶ原ひたぎは、嫌がらせに関して、どのくらいの長がある？',
    options: [
      { optionId: '0', text: '千年の長' },
      { optionId: '1', text: '一日の長' },
      { optionId: '2', text: '一年の長' },
      { optionId: '3', text: '十年の長' },
      { optionId: '4', text: '百年の長' },
    ],
  },
  {
    quizId: '233',
    question: '車で移動中、戦場ヶ原ひたぎは薔薇の花言葉は何だと言っている？',
    options: [
      { optionId: '0', text: '愚かな男' },
      { optionId: '1', text: 'あなたしかいない' },
      { optionId: '2', text: '密かな愛' },
      { optionId: '3', text: '何度生まれ変わっても貴方を殺す' },
      { optionId: '4', text: '意地悪な馬鹿' },
    ],
  },
  {
    quizId: '234',
    question: '車で移動中、戦場ヶ原ひたぎは阿良々木暦のことを何と言いかけた？',
    options: [
      { optionId: '0', text: 'ゴミ' },
      { optionId: '1', text: 'ちゅらら木くん' },
      { optionId: '2', text: 'こよこよ' },
      { optionId: '3', text: '馬鹿' },
      { optionId: '4', text: '童貞' },
    ],
  },
  {
    quizId: '235',
    question:
      '車で移動中、戦場ヶ原ひたぎは阿良々木暦を褒める際、以前人を褒めたのはいつだったという嘘を吐いた？',
    options: [
      {
        optionId: '0',
        text: '小学六年生のとき、隣の席の子がオセロで三連勝していたとき',
      },
      { optionId: '1', text: '先週ケシオトで神原と勝負したとき' },
      { optionId: '2', text: '中学一年生のとき、近所の犬がお手を成功したとき' },
      {
        optionId: '3',
        text: '自分が忍野さんとの約束を守り、きちんと十万円払ったとき',
      },
      { optionId: '4', text: '私がこの世に生を受けた瞬間' },
    ],
  },
  {
    quizId: '236',
    question:
      '「はいはい……そうさせてもらうよ」\nと言う阿良々木暦に対し、「はいは三回」だと言ったのは誰？',
    options: [
      { optionId: '0', text: '戦場ヶ原ひたぎ' },
      { optionId: '1', text: '神原駿河' },
      { optionId: '2', text: '八九寺真宵' },
      { optionId: '3', text: '羽川翼' },
      { optionId: '4', text: '千石撫子' },
    ],
  },
  {
    quizId: '237',
    question:
      'つばさキャット、戦場ヶ原ひたぎの台詞より問題です。\n「私は阿良々木くんの馬鹿話に付き合ってあげるほど、暇人でもなければ○○でもないのよ？」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '火星人' },
      { optionId: '1', text: '寛大' },
      { optionId: '2', text: '仲良し' },
      { optionId: '3', text: '羽川さん' },
      { optionId: '4', text: '麻痺' },
    ],
  },
  {
    quizId: '238',
    question:
      '阿良々木暦と戦場ヶ原ひたぎの初デート、車での移動は片道でどのくらいの時間？',
    options: [
      { optionId: '0', text: '二時間くらい' },
      { optionId: '1', text: '三十分くらい' },
      { optionId: '2', text: '一時間くらい' },
      { optionId: '3', text: '三時間くらい' },
      { optionId: '4', text: '四時間以上' },
    ],
  },
  {
    quizId: '239',
    question:
      '初デートで、戦場ヶ原ひたぎがセッティングのために、一人で車を降りたときに言い捨てた台詞は？',
    options: [
      { optionId: '0', text: 'お父さんと歓談でもしておいて頂戴' },
      { optionId: '1', text: '大人しく待っていて頂戴' },
      { optionId: '2', text: 'お父さんと仲良く過ごしておいて頂戴' },
      { optionId: '3', text: 'お父さんと何かあっても、笑って許してあげるわ' },
      { optionId: '4', text: 'お父さんに何かあったら、ただじゃおかないから' },
    ],
  },
  {
    quizId: '240',
    question:
      '戦場ヶ原父と阿良々木暦の会話中、戦場ヶ原父は戦場ヶ原母の事を何と言っていた？',
    options: [
      { optionId: '0', text: 'ひたぎの母親' },
      { optionId: '1', text: '妻' },
      { optionId: '2', text: '家内' },
      { optionId: '3', text: '女房' },
      { optionId: '4', text: '細君' },
    ],
  },
  {
    quizId: '241',
    question:
      'つばさキャット、戦場ヶ原父の台詞より問題です。\n「だから、しかるべき相手には、全体重をゆだねる。全力で甘える。愛するっていうのは、求めるってことだからね。自分の娘のことでなんだが、恋人にするには、○○だと思うよ」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '重過ぎる子' },
      { optionId: '1', text: '大変' },
      { optionId: '2', text: '楽じゃない子' },
      { optionId: '3', text: '面倒臭い子' },
      { optionId: '4', text: 'しんどい子' },
    ],
  },
  {
    quizId: '242',
    question: '阿良々木暦と戦場ヶ原ひたぎが初めてデートした場所は？',
    options: [
      { optionId: '0', text: 'ほしのさと天文台' },
      { optionId: '1', text: '星の宮天文台' },
      { optionId: '2', text: '美星天文台' },
      { optionId: '3', text: 'つきびかり天文台' },
      { optionId: '4', text: '一番星天文台' },
    ],
  },
  {
    quizId: '243',
    question: '初デートで星空を見た、阿良々木暦の感想は？',
    options: [
      { optionId: '0', text: '「すげえ――正直、言葉にならない」' },
      { optionId: '1', text: '「きれいだ――今までの何にも負けないくらい」' },
      { optionId: '2', text: '「ありがとう」' },
      { optionId: '3', text: '「こんな星空、初めて見た」' },
      { optionId: '4', text: '「この星空よりひたぎさんの方が美しいよ」' },
    ],
  },
  {
    quizId: '244',
    question:
      '初デートで星空を見た阿良々木暦に、戦場ヶ原ひたぎがまず説明した星は？',
    options: [
      { optionId: '0', text: '夏の大三角' },
      { optionId: '1', text: 'スピカ' },
      { optionId: '2', text: 'へびつかい座' },
      { optionId: '3', text: 'やまねこ座' },
      { optionId: '4', text: '北斗七星' },
    ],
  },
  {
    quizId: '245',
    question:
      '初デートで星空を見上げているときの戦場ヶ原ひたぎが言った、戦場ヶ原ひたぎが阿良々木暦にあげられるものでないのは？',
    options: [
      { optionId: '0', text: '手料理' },
      { optionId: '1', text: '勉強を教えてあげられること' },
      { optionId: '2', text: '可愛い後輩と、ぶっきらぼうなお父さん' },
      { optionId: '3', text: '星空' },
      { optionId: '4', text: '毒舌や暴言' },
    ],
  },
  {
    quizId: '246',
    question:
      'つばさキャット、戦場ヶ原ひたぎの台詞より問題です。\n「ただ……私は、怖い。付き合う前はそれほどでもなかったのだけれど――私は今、○○が、とても怖い」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '阿良々木くんを嫌いになること' },
      { optionId: '1', text: '阿良々木くんに嫌われること' },
      { optionId: '2', text: '今の生活を失うこと' },
      { optionId: '3', text: '阿良々木くんが留年すること' },
      { optionId: '4', text: '阿良々木くんが遠くに行っちゃうこと' },
    ],
  },
  {
    quizId: '247',
    question: '戦場ヶ原ひたぎの宝物は？',
    options: [
      { optionId: '0', text: '星空' },
      { optionId: '1', text: '思い出' },
      { optionId: '2', text: '阿良々木暦' },
      { optionId: '3', text: 'お父さん' },
      { optionId: '4', text: '今の生活' },
    ],
  },
  {
    quizId: '248',
    question: '阿良々木暦は、戦場ヶ原ひたぎのどういうところが好き？',
    options: [
      { optionId: '0', text: '全部好き' },
      {
        optionId: '1',
        text: '素直じゃないところ。可愛いところ。僕がピンチのときには手を差し伸べてくれるところ。',
      },
      {
        optionId: '2',
        text: '楽しいところ。優しいところ。僕がピンチのときには手を差し伸べてくれるところ。',
      },
      { optionId: '3', text: '格好いいお父さんがいるところ。' },
      {
        optionId: '4',
        text: 'きれいで、可愛くて、楽しくて、それでいて少し厳しいところ。',
      },
    ],
  },
  {
    quizId: '249',
    question:
      'つばさキャット、阿良々木暦のモノローグより問題です。\n『そうだ、大体、僕は友達と再会したくらいではしゃぎまくるような、薄い人間ではないのだ。○○を売りにしていきたいお年頃である。』\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'ドライでクール' },
      { optionId: '1', text: '男らしさ' },
      { optionId: '2', text: 'シャイな少年' },
      { optionId: '3', text: '落ち着いた大人っぽさ' },
      { optionId: '4', text: '知的男子' },
    ],
  },
  {
    quizId: '250',
    question:
      '「ふしゃーっ……こーほー、こーほー」\nという八九寺真宵の呼吸音を、阿良々木暦は何のようだと思った？',
    options: [
      { optionId: '0', text: 'ロボ超人' },
      { optionId: '1', text: 'ディオ' },
      { optionId: '2', text: 'ダースベイダー' },
      { optionId: '3', text: 'ウルトラマン' },
      { optionId: '4', text: 'ビートン' },
    ],
  },
  {
    quizId: '251',
    question: '阿良々木暦には詰襟姿が似合うと言っているのは？',
    options: [
      { optionId: '0', text: '八九寺真宵' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '羽川翼' },
      { optionId: '3', text: '千石撫子' },
      { optionId: '4', text: '神原駿河神原駿河' },
    ],
  },
  {
    quizId: '252',
    question: '私立直江津高校に応援団がない理由は？',
    options: [
      { optionId: '0', text: '部活動がそんなに頑張らないから' },
      { optionId: '1', text: '入る物好きがいないから' },
      { optionId: '2', text: '生徒会が同等の活動をしているから' },
      { optionId: '3', text: '吹奏楽部が同等の活動をしているから' },
      { optionId: '4', text: '歴史が浅く、まだ作られていないから' },
    ],
  },
  {
    quizId: '253',
    question:
      '阿良々木暦はどのような内面に反比例して、大人しい顔立ちをしている？',
    options: [
      { optionId: '0', text: '凶暴' },
      { optionId: '1', text: '冷酷' },
      { optionId: '2', text: '獰猛' },
      { optionId: '3', text: '変態' },
      { optionId: '4', text: '憂慮深い' },
    ],
  },
  {
    quizId: '254',
    question: '阿良々木暦の理想の自分像は？',
    options: [
      { optionId: '0', text: '背が高くて肩幅の広いマッチョな男' },
      { optionId: '1', text: '背の高い細マッチョ' },
      { optionId: '2', text: '身長180cmでガタイのいい男' },
      { optionId: '3', text: '思慮深そうな、荘厳さを持った男' },
      { optionId: '4', text: '眼鏡の似合う高身長の少年' },
    ],
  },
  {
    quizId: '255',
    question:
      'つばさキャット、阿良々木暦と八九寺真宵の会話より問題です。\n「ごめんなさいと謝れば、今なら許してやるぞ」\n「ふっ……\nそれは○○の台詞です、阿良々木さん」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: 'ダッチ' },
      { optionId: '1', text: 'こっち' },
      { optionId: '2', text: 'どっち' },
      { optionId: '3', text: 'リッチ' },
      { optionId: '4', text: 'アイ' },
    ],
  },
  {
    quizId: '256',
    question:
      'つばさキャット、八九寺真宵の台詞より問題です。\n「阿良々木さん、しばらく会わない間に、色々あったのですね。○○とはよく言ったものです」\n○○に入る慣用句は？',
    options: [
      { optionId: '0', text: '男子三日会わざれば括目してみよ' },
      { optionId: '1', text: '魚の水を得たるが如し' },
      { optionId: '2', text: '水は方円の器に随う' },
      { optionId: '3', text: '六十の手習い' },
      { optionId: '4', text: '若い時の苦労は買ってでもせよ' },
    ],
  },
  {
    quizId: '257',
    question:
      '頭は二つ、目は三つ。口は四つで歯は百本。手が七本に足が五本、象を丸呑みできる小さな動物は、なーんだ？',
    options: [
      { optionId: '0', text: 'イルカ' },
      { optionId: '1', text: '鵺' },
      { optionId: '2', text: '蛙' },
      { optionId: '3', text: '獏' },
      { optionId: '4', text: 'ニシシマバンディクート' },
    ],
  },
  {
    quizId: '258',
    question:
      '頭は猿で胴は狸、手足は虎で尾は蛇、鳴き声はトラツグミな動物は、なーんだ？',
    options: [
      { optionId: '0', text: '鵺' },
      { optionId: '1', text: 'イルカ' },
      { optionId: '2', text: '蛙' },
      { optionId: '3', text: '獏' },
      { optionId: '4', text: 'ニシシマバンディクート' },
    ],
  },
  {
    quizId: '259',
    question:
      '原作より問題です。\n「とにかく、○○さん」\n「～～。僕の名前は阿良々木だ」\n「失礼噛みました」\n「違う、わざとだ……」\n「噛みまみた」\n「わざとじゃないっ!?」\n「神はいた」\n「どんな奇跡体験をっ!?」\n○○に入るのは？',
    options: [
      { optionId: '0', text: 'ぼらら木' },
      { optionId: '1', text: 'むらら木' },
      { optionId: '2', text: '何良々木' },
      { optionId: '3', text: '修羅々木' },
      { optionId: '4', text: 'クララ木' },
    ],
  },
  {
    quizId: '260',
    question: '学士号は英語で？',
    options: [
      { optionId: '0', text: 'バカロリート' },
      { optionId: '1', text: 'アルミグティ' },
      { optionId: '2', text: 'ショタニール' },
      { optionId: '3', text: 'リムーバー' },
      { optionId: '4', text: 'フリケイン' },
    ],
  },
  {
    quizId: '261',
    question: '八九寺真宵が『前向き』的な意味合いで使っていた言葉は？',
    options: [
      { optionId: '0', text: 'プラスチック' },
      { optionId: '1', text: 'フルフェイス' },
      { optionId: '2', text: 'ビフォアターン' },
      { optionId: '3', text: 'フロントサイト' },
      { optionId: '4', text: 'アドバンス' },
    ],
  },
  {
    quizId: '262',
    question: '八九寺真宵の語る、阿良々木暦の売りとは？',
    options: [
      { optionId: '0', text: '一見幸せなようだけれど、よく考えてみれば不幸' },
      { optionId: '1', text: '公共の場で変態行為に身を任せられる' },
      { optionId: '2', text: 'ボケに対して、そこそこの突っ込みを入れる' },
      { optionId: '3', text: '一途と言いつつ、ハーレムを形成していく' },
      { optionId: '4', text: '常にマーフィーの法則で言い訳する' },
    ],
  },
  {
    quizId: '263',
    question:
      'その昔、CAPCOMが開発した、クイズに答えながら七人ほど登場する女の子をのキャラクターと仲良くなって、半年掛けて好感度を上げながら、最後には復活した魔王を倒して意中の女の子とハッピーエンドになることを目指す、恋愛クイズゲームのタイトルは？',
    options: [
      { optionId: '0', text: 'QUIZなないろDREAMS　虹色町の奇跡' },
      { optionId: '1', text: '青春クイズカラフルハイスクール' },
      { optionId: '2', text: 'プリンセスメーカー' },
      { optionId: '3', text: 'センチメンタルグラフティ' },
      { optionId: '4', text: 'ふしぎの国のアンジェリーク' },
    ],
  },
  {
    quizId: '264',
    question: '阿良々木暦が八九寺に諭された正論は？',
    options: [
      { optionId: '0', text: '自分が言われて嫌なことを他人に言ってはいけない' },
      { optionId: '1', text: '他人には優しくしないといけない' },
      { optionId: '2', text: '嘘を吐いてはいけない' },
      {
        optionId: '3',
        text: 'お兄さんなんだから、妹さんには優しくしないといけない',
      },
      { optionId: '4', text: 'ご両親は大切にしないといけない' },
    ],
  },
  {
    quizId: '265',
    question:
      'つばさキャットより問題です。\n八九寺真宵が忍野忍を国道沿いのミスタードーナツで見かけたのはいつ頃？',
    options: [
      { optionId: '0', text: '六月十三日午後五時頃' },
      { optionId: '1', text: '六月十三日午後三時頃' },
      { optionId: '2', text: '六月十四日午後三時頃' },
      { optionId: '3', text: '六月十四日午後三時頃' },
      { optionId: '4', text: '六月十四日午後一時頃' },
    ],
  },
  {
    quizId: '266',
    question:
      'つばさキャットより問題です。\n八九寺真宵のクラスの今月の標語は？',
    options: [
      { optionId: '0', text: 'ロリコンに優しく' },
      { optionId: '1', text: 'エロに寛容に' },
      { optionId: '2', text: '困っている人に優しく' },
      { optionId: '3', text: '町の平和維持' },
      { optionId: '4', text: 'ショタコンに優しく' },
    ],
  },
  {
    quizId: '267',
    question:
      'つばさキャットより問題です。\n阿良々木暦に羽川翼から来たメールは何から始まり、何で結ばれていた？',
    options: [
      { optionId: '0', text: '『前略』から始まり『草々不一』で結ばれていた' },
      { optionId: '1', text: '『拝啓』から始まり『敬具』で結ばれていた' },
      { optionId: '2', text: '『急啓』から始まり『草々』で結ばれていた' },
      {
        optionId: '3',
        text: '『恭啓』から始まり『あらあらかしこ』で結ばれていた',
      },
      { optionId: '4', text: '『謹啓』から始まり『謹言』で結ばれていた' },
    ],
  },
  {
    quizId: '268',
    question: '阿良々木暦が家族を除いて初めて見たパジャマ姿の女の子は？',
    options: [
      { optionId: '0', text: '羽川翼' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '神原駿河' },
      { optionId: '3', text: '千石撫子' },
      { optionId: '4', text: '八九寺真宵' },
    ],
  },
  {
    quizId: '269',
    question:
      'ラジオネーム『林檎をむいて歩こう』さんは、某連続ドラマのDVDを借りる際、何巻が抜けていて、七並べのようだと思った？',
    options: [
      { optionId: '0', text: '八巻' },
      { optionId: '1', text: '五巻' },
      { optionId: '2', text: '六巻' },
      { optionId: '3', text: '九巻' },
      { optionId: '4', text: '十巻' },
    ],
  },
  {
    quizId: '270',
    question: '隠れ巨乳といえば？',
    options: [
      { optionId: '0', text: '羽川翼' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '神原駿河' },
      { optionId: '3', text: '千石撫子' },
      { optionId: '4', text: '八九寺真宵' },
    ],
  },
  {
    quizId: '271',
    question:
      'つばさキャット、忍野メメの台詞より問題です。\n「それに、委員長ちゃん……だよね。僕は女性に○○を変えられると誰だかわかんなくなっちゃうんだけど、うん、その眼鏡は間違いなく委員長ちゃんだ。はっはー、委員長ちゃんは久し振り、阿良々木くんは一日振り」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '髪型' },
      { optionId: '1', text: '服装' },
      { optionId: '2', text: '靴' },
      { optionId: '3', text: '化粧' },
      { optionId: '4', text: '香水' },
    ],
  },
  {
    quizId: '272',
    question: '怪異『障り猫』の別名は？',
    options: [
      { optionId: '0', text: '白銀猫' },
      { optionId: '1', text: '尾無猫' },
      { optionId: '2', text: '恨み猫' },
      { optionId: '3', text: '救い猫' },
      { optionId: '4', text: '跳美猫' },
    ],
  },
  {
    quizId: '273',
    question: '忍野メメが羽川翼のことを言うとき、枕詞のようにつけていたのは？',
    options: [
      { optionId: '0', text: '阿良々木くんならともかく' },
      { optionId: '1', text: '賢い委員長ちゃんなら' },
      { optionId: '2', text: '阿良々木くんと違って' },
      { optionId: '3', text: '超高校生級の委員長ちゃんなら' },
      { optionId: '4', text: '聡明な委員長ちゃんなら' },
    ],
  },
  {
    quizId: '274',
    question: '羽川翼の最初の苗字は？',
    options: [
      { optionId: '0', text: '不明' },
      { optionId: '1', text: '宮崎' },
      { optionId: '2', text: '野村' },
      { optionId: '3', text: '竹添' },
      { optionId: '4', text: '佐久川' },
    ],
  },
  {
    quizId: '275',
    question: '羽川翼の苗字が羽川になった年齢は？',
    options: [
      { optionId: '0', text: '二歳以下' },
      { optionId: '1', text: '三歳' },
      { optionId: '2', text: '四歳' },
      { optionId: '3', text: '五歳' },
      { optionId: '4', text: '六歳以上' },
    ],
  },
  {
    quizId: '276',
    question: '羽川翼にとって休日は？',
    options: [
      { optionId: '0', text: '散歩の日' },
      { optionId: '1', text: '図書館の日' },
      { optionId: '2', text: '読書の日' },
      { optionId: '3', text: '日帰り旅行の日' },
      { optionId: '4', text: '息抜きの日' },
    ],
  },
  {
    quizId: '277',
    question:
      'つばさキャット、阿良々木暦と羽川翼の会話より問題です。\n「このことは、誰にも言わないでください。黙ってくれたら、私、なんでもするから」\n「…………」\n「お願いします」\n「○○」\n○○に入る台詞は？',
    options: [
      { optionId: '0', text: '……ああ。わかったよ……' },
      {
        optionId: '1',
        text: 'え!?　マジで!?　羽川が何でもしてくれるの!? やったあ！',
      },
      { optionId: '2', text: '……了解したよ' },
      { optionId: '3', text: '……そうかよ' },
      { optionId: '4', text: 'はい' },
    ],
  },
  {
    quizId: '278',
    question: '忍野メメが羽川翼の猫耳姿を見て思い出した漫画は？',
    options: [
      { optionId: '0', text: 'ねこ・ねこ・幻想曲' },
      { optionId: '1', text: 'きんぎょ注意報！' },
      { optionId: '2', text: 'ブルーフレンド' },
      { optionId: '3', text: '3丁目のタマ うちのタマ知りませんか?' },
      { optionId: '4', text: '犬・けん・ケン物語、水の町' },
    ],
  },
  {
    quizId: '279',
    question:
      'つばさキャット、阿良々木暦と忍野メメの会話より問題です。\n「忍野……訊きたいことがあるんだが」\n「奇遇だねえ。僕も阿良々木くんから、訊かれたいことがあったんだよ」\n「忍はどうした」\n「うん、それそれ。\n忍ちゃん、○○に出ちゃった」\n○○に入るのは？',
    options: [
      { optionId: '0', text: '自分探しの旅' },
      { optionId: '1', text: 'ドーナツ買い' },
      { optionId: '2', text: '家出' },
      { optionId: '3', text: 'どこか' },
      { optionId: '4', text: '帰省' },
    ],
  },
  {
    quizId: '280',
    question:
      'つばさキャットより問題です。\n行方不明になった忍野忍を捜すため、阿良々木暦は何も食べず、何も飲まず、どのくらいの時間ペダルを漕ぎ続けた？',
    options: [
      { optionId: '0', text: '九時間' },
      { optionId: '1', text: '三時間' },
      { optionId: '2', text: '五時間' },
      { optionId: '3', text: '七時間' },
      { optionId: '4', text: '十一時間' },
    ],
  },
  {
    quizId: '281',
    question:
      'つばさキャット、八九寺真宵の台詞より問題です。\n「迷子探しとなると確かに○○を争う事態ですが、冷静さを失ってはいけません」\n○○に入る四字熟語は？',
    options: [
      { optionId: '0', text: '一国一城' },
      { optionId: '1', text: '一刻一秒' },
      { optionId: '2', text: '一栄一辱' },
      { optionId: '3', text: '一汁一菜' },
      { optionId: '4', text: '一期一会' },
    ],
  },
  {
    quizId: '282',
    question: '阿良々木暦が住んでいる町での、悲しい伝説は？',
    options: [
      { optionId: '0', text: 'パチンコ店ですらもはやらず潰れた' },
      { optionId: '1', text: 'ゲームセンターですらもはやらず潰れた' },
      { optionId: '2', text: '祭りに呼ばれた芸能人が怒って帰った' },
      { optionId: '3', text: '出身有名人が出身地を誤魔化していた' },
      { optionId: '4', text: '人数不足で廃校になった学校が三校ある' },
    ],
  },
  {
    quizId: '283',
    question: '千石撫子のラジオネームは？',
    options: [
      { optionId: '0', text: '大熊猫大好き' },
      { optionId: '1', text: 'すぶりをするそぶり' },
      { optionId: '2', text: '林檎をむいて歩こう' },
      { optionId: '3', text: '夢見がちな症状' },
      { optionId: '4', text: '私の道は人並みのルート' },
    ],
  },
  {
    quizId: '284',
    question:
      'つばさキャットより問題です。\n阿良々木暦が電話したときに、神原駿河が興じていたゲームは？',
    options: [
      { optionId: '0', text: 'オシャレ魔女ラブandベリー' },
      { optionId: '1', text: 'ムシキング' },
      { optionId: '2', text: '古代王者恐竜キング' },
      { optionId: '3', text: 'キラキラアイドル リカちゃん' },
      { optionId: '4', text: 'きらりん☆レボリューション' },
    ],
  },
  {
    quizId: '285',
    question:
      'つばさキャットより問題です。\n神原駿河のエロさは、何という言葉の響きにいやらしさを感じるレベル？',
    options: [
      { optionId: '0', text: '女性専用車両' },
      { optionId: '1', text: '裸電球' },
      { optionId: '2', text: '成長期' },
      { optionId: '3', text: '反抗期' },
      { optionId: '4', text: '人体模型' },
    ],
  },
  {
    quizId: '286',
    question:
      '神原駿河は戦場ヶ原ひたぎに初デートの自慢話を何時間ほど聞かされた？',
    options: [
      { optionId: '0', text: '五時間' },
      { optionId: '1', text: '一時間' },
      { optionId: '2', text: '二時間' },
      { optionId: '3', text: '三時間' },
      { optionId: '4', text: '四時間以上' },
    ],
  },
  {
    quizId: '287',
    question:
      '神原駿河を本気で走らせることができるのは、阿良々木先輩と、戦場ヶ原先輩と、あと一つは何？',
    options: [
      { optionId: '0', text: 'BL小説の発売日' },
      { optionId: '1', text: '羽川先輩' },
      { optionId: '2', text: '可愛らしい少女' },
      { optionId: '3', text: '可愛らしい少年' },
      { optionId: '4', text: 'バスケットボールの試合' },
    ],
  },
  {
    quizId: '288',
    question: '進化した神原駿河が名乗った名前は？',
    options: [
      { optionId: '0', text: '神原Ω' },
      { optionId: '1', text: '神原Σ' },
      { optionId: '2', text: '神原α' },
      { optionId: '3', text: '神原β' },
      { optionId: '4', text: '神原λ' },
    ],
  },
  {
    quizId: '289',
    question:
      '「はいはい……なんでも言えよ」\nと言う阿良々木暦に対し、「恋は一回」だと言ったのは誰？',
    options: [
      { optionId: '0', text: '神原駿河' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '八九寺真宵' },
      { optionId: '3', text: '千石撫子' },
      { optionId: '4', text: '羽川翼' },
    ],
  },
  {
    quizId: '290',
    question:
      '戦場ヶ原ひたぎは、鎌倉幕府が成立した年をどのように記憶している？',
    options: [
      { optionId: '0', text: 'いい国作れず、鎌倉幕府' },
      { optionId: '1', text: '一々国なんて作る、鎌倉幕府' },
      { optionId: '2', text: 'いい、急に動くな、鎌倉幕府' },
      { optionId: '3', text: 'ひどい国になった、鎌倉幕府' },
      { optionId: '4', text: 'いい国作ろう、鎌倉幕府' },
    ],
  },
  {
    quizId: '291',
    question:
      '阿良々木暦にブラック羽川が初めに提案した、羽川翼のおっぱいを揉ましてあげるための条件は？',
    options: [
      { optionId: '0', text: '一カツオブシ' },
      { optionId: '1', text: '一マタタビ' },
      { optionId: '2', text: '一キャットフード' },
      { optionId: '3', text: '一ねこじゃらし' },
      { optionId: '4', text: '一まり' },
    ],
  },
  {
    quizId: '292',
    question:
      '阿良々木暦とブラック羽川、どっちがより馬鹿か決めるため、初めに提案した勝負種目は？',
    options: [
      { optionId: '0', text: '将棋' },
      { optionId: '1', text: '囲碁' },
      { optionId: '2', text: 'ポーカー' },
      {
        optionId: '3',
        text: 'ストップウォッチで、先に一秒ジャストで停めた方が勝ち',
      },
      { optionId: '4', text: '腕相撲' },
    ],
  },
  {
    quizId: '293',
    question:
      '鬼は――ただの血液異常に。\n猫は――ただの多重人格に。\n蟹は――ただの病気に。\n蝸牛は――ただの迷子に。\n猿は――ただの通り魔に。\n蛇は――ただの○○に。\n怪異は――ただの現象になる。\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '疼痛' },
      { optionId: '1', text: '鈍痛' },
      { optionId: '2', text: '湿疹' },
      { optionId: '3', text: '皮膚病' },
      { optionId: '4', text: '倦怠感' },
    ],
  },
  {
    quizId: '294',
    question:
      'つばさキャット、阿良々木暦の台詞より問題です。\n「なんだよ。一人で考えるなよ。人間の世界にゃこういう諺があるんだぜ？　○○ってな――」\n○○に入ることわざは？',
    options: [
      { optionId: '0', text: '三人寄れば文殊の知恵' },
      { optionId: '1', text: '下手の考え休むに似たり' },
      { optionId: '2', text: '蛇の足より人の足' },
      { optionId: '3', text: '和を以て貴しとなす' },
      { optionId: '4', text: '人生意気に感ず' },
    ],
  },
  {
    quizId: '295',
    question:
      '阿良々木暦の忍野忍に関しての台詞より問題です。\n「あいつが○○死ぬのなら、僕の命は○○まででいい」\n○○に入る言葉は？',
    options: [
      { optionId: '0', text: '明日' },
      { optionId: '1', text: '今日' },
      { optionId: '2', text: '今' },
      { optionId: '3', text: '今年' },
      { optionId: '4', text: '今夜' },
    ],
  },
  {
    quizId: '296',
    question: '羽川翼が阿良々木暦を副委員長にした理由は？',
    options: [
      { optionId: '0', text: '阿良々木暦と少しでも一緒にいたかったから' },
      { optionId: '1', text: '阿良々木暦を更生させるため' },
      { optionId: '2', text: '阿良々木暦のことをよく知るため' },
      { optionId: '3', text: '知り合いであるほうが落ち着くため' },
      { optionId: '4', text: '阿良々木暦をよく知りたかったから' },
    ],
  },
  {
    quizId: '297',
    question: '阿良々木暦が生まれて初めて、真剣に好きになった相手は？',
    options: [
      { optionId: '0', text: '戦場ヶ原ひたぎ' },
      { optionId: '1', text: '羽川翼' },
      { optionId: '2', text: '保育園の先生' },
      { optionId: '3', text: '小学三年生のときの担任' },
      {
        optionId: '4',
        text: 'キスショット・アセロラオリオン・ハートアンダーブレード',
      },
    ],
  },
  {
    quizId: '298',
    question: '障り猫に後ろから抱き着かれた阿良々木暦が、助けを求めた相手は？',
    options: [
      { optionId: '0', text: '忍野忍' },
      { optionId: '1', text: '戦場ヶ原ひたぎ' },
      { optionId: '2', text: '神原駿河' },
      { optionId: '3', text: '忍野メメ' },
      { optionId: '4', text: '助けを求めていない' },
    ],
  },
  {
    quizId: '299',
    question:
      'つばさキャット、ブラック羽川から戻った羽川翼の台詞より問題です。\n「私との友情よりも私に恩返しすることの方がずっと大事だなんて――そんな寂しいこと、言わないでよ」\nに続く台詞は？',
    options: [
      { optionId: '0', text: '阿良々木くん……きちんとしなさい' },
      { optionId: '1', text: '阿良々木くん……誠実にね' },
      { optionId: '2', text: '阿良々木くん……宜しくお願いします' },
      { optionId: '3', text: '阿良々木くん……勉強しなさい' },
      { optionId: '4', text: '阿良々木くん……仲良くしてください' },
    ],
  },
  {
    quizId: '300',
    question:
      'つばさキャットより問題です。\nブラック羽川によって倒れた阿良々木暦を、家まで運んだのは？',
    options: [
      { optionId: '0', text: '阿良々木火憐と阿良々木月火' },
      { optionId: '1', text: '神原駿河' },
      { optionId: '2', text: '忍野忍' },
      { optionId: '3', text: '戦場ヶ原ひたぎ' },
      { optionId: '4', text: '警察' },
    ],
  },
  {
    quizId: '301',
    question:
      'つばさキャット、阿良々木暦と戦場ヶ原ひたぎの会話より問題です。\n「今度のデートは、\n阿良々木くんがプランニングしなさい。」\n「…………」\n「変なところに連れて行ったら○○わよ」\n「……了解」\n○○に入るのは？\n',
    options: [
      { optionId: '0', text: '皮を剥ぐ' },
      { optionId: '1', text: '殺す' },
      { optionId: '2', text: 'パチン' },
      { optionId: '3', text: '目を潰す' },
      { optionId: '4', text: '切り落とす' },
    ],
  },
  {
    quizId: '302',
    question:
      '阿良々木暦、戦場ヶ原ひたぎ、羽川翼、神原駿河の四人が、声を揃えて異口同音、忍野メメの事を何と言った？',
    options: [
      { optionId: '0', text: 'お人よし' },
      { optionId: '1', text: 'お調子者' },
      { optionId: '2', text: 'あんぽんたん' },
      { optionId: '3', text: '守銭奴' },
      { optionId: '4', text: '放浪者' },
    ],
  },
  {
    quizId: '303',
    question: '阿良々木暦が三年のときの文化祭、クラスの出し物は？',
    options: [
      { optionId: '0', text: 'お化け屋敷' },
      { optionId: '1', text: '喫茶店' },
      { optionId: '2', text: '巨大迷路' },
      { optionId: '3', text: 'プラネタリウム' },
      { optionId: '4', text: '歴史・風土展' },
    ],
  },
  {
    quizId: '304',
    question: '化物語は？',
    options: [
      { optionId: '0', text: '100パーセント趣味で書かれた小説' },
      { optionId: '1', text: '120パーセント趣味で書かれた小説' },
      { optionId: '2', text: '200パーセント趣味で書かれた小説' },
      { optionId: '3', text: '猫パーセント趣味で書かれた小説' },
      { optionId: '4', text: '100パーセント修羅で書かれた小説' },
    ],
  },
  {
    quizId: '305',
    question: '化物語上巻のキャッチコピーは？',
    options: [
      { optionId: '0', text: '青春に、おかしなものはつきものだ！' },
      { optionId: '1', text: '青春を、おかしくするのはつきものだ！' },
      { optionId: '2', text: '青春は、いたみなしでは過ごせない。' },
      { optionId: '3', text: '青春は、ほんものになるための戦いだ。' },
      { optionId: '4', text: '青春はにせものだけでは終わらない。' },
    ],
  },
  {
    quizId: '306',
    question: '化物語下巻のキャッチコピーは？',
    options: [
      { optionId: '0', text: '青春を、おかしくするのはつきものだ！' },
      { optionId: '1', text: '青春に、おかしなものはつきものだ！' },
      { optionId: '2', text: '青春は、いたみなしでは過ごせない。' },
      { optionId: '3', text: '青春は、ほんものになるための戦いだ。' },
      { optionId: '4', text: '青春はにせものだけでは終わらない。' },
    ],
  },
];
